/* Fotobaren — Booking wizard (bookingflyt v5) + inline availability calendar.
   Availability comes live from IzyRent; the finished booking is added to the
   cart with IzyRent-compatible line item properties before checkout. */
(function () {
  'use strict';

  var MONTHS = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];
  var DOW_SHORT = ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'];
  var DOW_NAMES = ['man', 'tir', 'ons', 'tor', 'fre', 'lør', 'søn'];
  var STEPS = ['Dato', 'Anledning', 'Levering', 'Kontakt', 'Betal'];
  var OCC = {
    privat: ['Bryllup', 'Konfirmasjon', 'Dåp', 'Bursdag', 'Jubileum', 'Annet'],
    bedrift: ['Firmafest', 'Julebord', 'Kickoff', 'Messe', 'Konferanse', 'Annet'],
  };
  /* Fallback if metaobjects are empty / not published to storefront yet. */
  var PACKAGES_FALLBACK = {
    bryllup: { title: 'Bryllupspakken', seg: 'privat', occ: 'Bryllup', handles: ['egen-logo-grafikk-pa-bildene'], variantIds: [], delivery: '', displayPrice: '3.490 kr' },
    fest: { title: 'Festpakken', seg: 'privat', occ: 'Bursdag', handles: [], variantIds: [], delivery: '', displayPrice: '2.990 kr' },
    bedrift: { title: 'Bedriftspakken', seg: 'bedrift', occ: 'Firmafest', handles: ['egen-logo-grafikk-pa-bildene'], variantIds: [], delivery: 'budbil', displayPrice: '3.990 kr' },
  };
  /* Example peak rules — replaced by shop.metaobjects.fb_price_rule when seeded. */
  var PRICE_RULES_FALLBACK = [
    { key: 'busy-25', title: 'Høy etterspørsel', type: 'busy', busyFrom: 25, amount: 49000, variantId: null },
    { key: 'busy-40', title: 'Svært høy etterspørsel', type: 'busy', busyFrom: 40, amount: 79000, variantId: null },
  ];

  function packagesMap() {
    var c = getConfig();
    var map = {};
    var list = (c && c.packages) || [];
    list.forEach(function (p) {
      if (!p || !p.key) return;
      map[String(p.key).toLowerCase()] = {
        title: p.title || p.key,
        seg: p.seg === 'bedrift' ? 'bedrift' : 'privat',
        occ: p.occ || '',
        handles: p.handles || [],
        variantIds: (p.variantIds || []).map(String),
        delivery: p.delivery || '',
        displayPrice: p.displayPrice || '',
      };
    });
    if (!Object.keys(map).length) {
      Object.keys(PACKAGES_FALLBACK).forEach(function (k) { map[k] = PACKAGES_FALLBACK[k]; });
    }
    return map;
  }

  function getPackage(key) {
    if (!key) return null;
    return packagesMap()[String(key).toLowerCase()] || null;
  }

  function packageFromOpts(opts) {
    var key = String((opts && opts.packageKey) || '').toLowerCase();
    if (getPackage(key)) return key;
    var title = String((opts && opts.packageTitle) || '').toLowerCase();
    if (/bryllup/.test(title) && getPackage('bryllup')) return 'bryllup';
    if (/bedrift/.test(title) && getPackage('bedrift')) return 'bedrift';
    if (/fest/.test(title) && getPackage('fest')) return 'fest';
    return '';
  }

  function packageVariantIds(pkg) {
    if (!pkg) return [];
    var ids = (pkg.variantIds || []).map(String);
    if (ids.length) return ids;
    var handles = (pkg.handles || []).map(function (h) { return String(h || '').toLowerCase(); });
    if (!handles.length) return [];
    return addonList().filter(function (a) {
      return handles.indexOf(String(a.handle || '').toLowerCase()) !== -1;
    }).map(function (a) { return String(a.variantId); });
  }

  function isPackageIncluded(variantId) {
    if (!S || !S.packageKey) return false;
    var ids = packageVariantIds(getPackage(S.packageKey));
    return ids.indexOf(String(variantId)) !== -1;
  }

  function applyPackagePreset(state) {
    var pkg = getPackage(state.packageKey);
    if (!pkg) return;
    state.seg = pkg.seg;
    if (pkg.occ && OCC[state.seg] && OCC[state.seg].indexOf(pkg.occ) !== -1) state.occ = pkg.occ;
    if (!state.packageTitle) state.packageTitle = pkg.title || '';
    if (!state.packagePrice && pkg.displayPrice) state.packagePrice = pkg.displayPrice;
    var prev = S;
    S = state;
    packageVariantIds(pkg).forEach(function (vid) {
      state.addons[vid] = true;
    });
    S = prev;
    preferPackageDelivery(state);
  }

  /** Bedriftspakken includes door delivery (budbil) where available — not opp-rigg. */
  function preferPackageDelivery(state) {
    if (!state) return;
    var pkg = getPackage(state.packageKey);
    var want = pkg && pkg.delivery;
    if (!want) return;
    var region = regionOf(state.postnr);
    if (!region) return;
    var opts = deliveriesFor(region);
    if (!opts.some(function (o) { return o.id === want; })) return;
    if (!state.delivery || state.delivery === 'posten' || state.delivery === 'henting') {
      state.delivery = want;
    }
  }

  /* ---- peak / demand price rules (metaobjects fb_price_rule) ---- */
  function priceRulesList() {
    var c = getConfig();
    var list = (c && c.priceRules) || [];
    if (list.length) {
      return list.map(function (r) {
        return {
          key: r.key,
          title: r.title || r.key,
          type: String(r.type || 'busy').toLowerCase(),
          busyFrom: parseInt(r.busyFrom, 10) || 0,
          dateFrom: r.dateFrom || null,
          dateTo: r.dateTo || null,
          amount: parseInt(r.amount, 10) || 0,
          variantId: r.variantId || null,
        };
      });
    }
    return PRICE_RULES_FALLBACK.slice();
  }

  function maxOccupancyInRange() {
    if (S.start === null) return 0;
    var end = effEnd();
    var max = 0;
    for (var d = S.start; d <= end; d = addDays(d, 1)) {
      var n = (occupancy && occupancy[d]) || 0;
      if (n > max) max = n;
    }
    return max;
  }

  function dateOverlapsRule(rule) {
    if (!rule.dateFrom && !rule.dateTo) return true;
    if (S.start === null) return false;
    var start = S.start;
    var end = effEnd();
    var from = rule.dateFrom || '0000-01-01';
    var to = rule.dateTo || '9999-12-31';
    return start <= to && end >= from;
  }

  /** Matching rules for current selection. Busy: highest threshold only. */
  function matchingPriceRules() {
    if (S.start === null) return [];
    var rules = priceRulesList();
    var maxOcc = maxOccupancyInRange();
    var busyBest = null;
    var others = [];
    rules.forEach(function (r) {
      if (!r || !r.amount) return;
      if (r.type === 'busy') {
        if (maxOcc >= r.busyFrom) {
          if (!busyBest || r.busyFrom > busyBest.busyFrom) busyBest = r;
        }
        return;
      }
      if ((r.type === 'calendar' || r.type === 'discount') && dateOverlapsRule(r)) {
        others.push(r);
      }
    });
    var out = [];
    if (busyBest) out.push(busyBest);
    return out.concat(others);
  }

  function priceRulesCents() {
    return matchingPriceRules().reduce(function (sum, r) { return sum + r.amount; }, 0);
  }

  function renderPackageBanner() {
    if (!S || !S.packageKey) return '';
    var pkg = getPackage(S.packageKey) || {};
    var title = S.packageTitle || pkg.title || 'Valgt pakke';
    var from = S.packagePrice ? 'Fra ' + S.packagePrice.replace(/^fra\s+/i, '') : '';
    var html = '<div class="fb-bw__notice fb-bw__notice--coral fb-bw__package">';
    html += ICONS.pkg + '<span><strong>' + esc(title) + '</strong> er valgt.';
    if (from) html += ' Pakkepris ' + esc(from) + '.';
    html += ' Inkluderte produkter legges i handlekurven — prisen under oppdateres når du velger dato.</span></div>';
    return html;
  }

  var MAX_DAYS = 28;

  var ICONS = {
    x: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    check: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    chevL: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    chevR: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    cal: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>',
    pkg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5M12 22V12"/></svg>',
    pin: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>',
    user: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"/><path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    shield: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>',
    arrowR: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>',
    clock: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>',
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var n = Math.round(cents / 100);
    return n.toLocaleString('nb-NO') + ' kr';
  }

  /* ---- date helpers (all days are "YYYY-MM-DD" strings) ---- */
  function toKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function fromKey(k) {
    var p = k.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function addDays(k, n) {
    var d = fromKey(k);
    d.setDate(d.getDate() + n);
    return toKey(d);
  }
  function diffDays(a, b) {
    return Math.round((fromKey(b) - fromKey(a)) / 86400000);
  }
  function dow(k) {
    // 0 = Monday … 6 = Sunday
    return (fromKey(k).getDay() + 6) % 7;
  }
  function isWeekend(k) {
    return dow(k) >= 4; // fre, lør, søn
  }
  function fmtDay(k) {
    var d = fromKey(k);
    var s = d.getDate() + '. ' + MONTHS[d.getMonth()];
    if (d.getFullYear() !== new Date().getFullYear()) s += ' ' + d.getFullYear();
    return s;
  }
  function fmtIzy(k) {
    var d = fromKey(k);
    var m = MONTHS[d.getMonth()];
    return d.getDate() + ' ' + m.charAt(0).toUpperCase() + m.slice(1) + ' ' + d.getFullYear();
  }
  function todayKey() {
    return toKey(new Date());
  }

  /* ---- config + availability ---- */
  var config = null;
  var blocked = null; // Set of "YYYY-MM-DD" at full stock
  var occupancy = null; // { "YYYY-MM-DD": occupiedCount } — includes in-transit units
  var availPromise = null;

  function getConfig() {
    if (config) return config;
    var el = document.querySelector('[data-fb-booking-config]');
    if (!el) return null;
    try { config = JSON.parse(el.textContent); } catch (e) { return null; }
    config.durations = config.product.variants.map(function (v) {
      var t = v.title.toLowerCase();
      var isHelg = /helg|weekend/.test(t);
      var days = isHelg ? 3
        : /year/.test(t) ? 365
        : /month/.test(t) ? 30
        : /week/.test(t) ? 7
        : (parseInt(t, 10) || 1);
      return { id: v.id, title: v.title, price: v.price, days: days, helg: isHelg };
    }).sort(function (a, b) {
      if (a.days !== b.days) return a.days - b.days;
      // Prefer non-Helg when sorting equal lengths so exact "3 days" wins over Helg for weekdays.
      return (a.helg === b.helg) ? 0 : a.helg ? 1 : -1;
    });
    return config;
  }

  /** Exact Fri–Sun weekend package (CSV: 1 helg = 2950).
      dow() is Mon=0 … Sun=6, so Friday=4 and Sunday=6. */
  var HELG_FALLBACK_CENTS = 295000;

  function isPureWeekendRange() {
    if (S.start === null) return false;
    var end = effEnd();
    if (rentalDays() !== 3) return false;
    return dow(S.start) === 4 && dow(end) === 6;
  }

  function helgVariant() {
    var c = getConfig();
    if (!c || !c.durations) return null;
    for (var i = 0; i < c.durations.length; i++) {
      if (c.durations[i].helg) return c.durations[i];
    }
    return null;
  }

  function variantForDays(days) {
    var c = getConfig();
    var i;
    // Pure weekend → dedicated Helg variant when present (CSV prismatrise).
    // Never fall through to weekday "3 days" (6723) for Fri–Sun.
    if (isPureWeekendRange()) {
      var helg = helgVariant();
      if (helg) return helg;
      return {
        id: null,
        title: 'Helg',
        price: HELG_FALLBACK_CENTS,
        days: 3,
        helg: true,
        fallback: true,
      };
    }
    // Exact day-count match (skip Helg — that is weekend-only).
    for (i = 0; i < c.durations.length; i++) {
      if (!c.durations[i].helg && c.durations[i].days === days) return c.durations[i];
    }
    // Next covering duration (skip Helg).
    for (i = 0; i < c.durations.length; i++) {
      if (!c.durations[i].helg && c.durations[i].days >= days) return c.durations[i];
    }
    for (i = c.durations.length - 1; i >= 0; i--) {
      if (!c.durations[i].helg) return c.durations[i];
    }
    return c.durations[c.durations.length - 1];
  }

  function stockCount() {
    var c = getConfig();
    var n = c && parseInt(c.stock, 10);
    return n > 0 ? n : 55;
  }

  /* Per-day concurrency from IzyRent's start/end/single markers.
     Occupancy includes units already out / in transit (carry from open ends).
     A date is fully blocked only when occupied >= configured stock. */
  function computeOccupancy(data, stock) {
    var blockedSet = new Set();
    var occ = {};
    var singles = {}, starts = {}, ends = {};
    var minDay = null, maxDay = null;
    Object.keys(data || {}).forEach(function (key) {
      var m = key.match(/^(\d{4})\/(\d{2})\/(\d{2})(?:_(start|end))?$/);
      if (!m) return;
      var day = m[1] + '-' + m[2] + '-' + m[3];
      var count = (data[key] && data[key].count) || 0;
      if (count < 1) return;
      var bucket = m[4] === 'start' ? starts : m[4] === 'end' ? ends : singles;
      bucket[day] = (bucket[day] || 0) + count;
      if (minDay === null || day < minDay) minDay = day;
      if (maxDay === null || day > maxDay) maxDay = day;
    });
    if (minDay === null) return { blocked: blockedSet, occupancy: occ };
    // Ends without a start inside the window belong to bookings already in
    // progress before it — they occupy units from minDay until their end day.
    var carry = 0, run = 0, d;
    for (d = minDay; d <= maxDay; d = addDays(d, 1)) {
      run += starts[d] || 0;
      run -= ends[d] || 0;
      if (run < 0) { carry -= run; run = 0; }
    }
    var active = carry;
    for (d = minDay; d <= maxDay; d = addDays(d, 1)) {
      active += starts[d] || 0;
      var used = active + (singles[d] || 0);
      if (used > 0) occ[d] = used;
      if (used >= stock) blockedSet.add(d);
      active -= ends[d] || 0; // end day itself still occupies the unit
      if (active < 0) active = 0;
    }
    return { blocked: blockedSet, occupancy: occ };
  }

  function fetchAvailability() {
    if (availPromise) return availPromise;
    var c = getConfig();
    var stock = stockCount();
    var variantStock = { product: { stock: String(stock), duration: 0, interval: 0, disabledDates: [], disabledCalendar: false } };
    c.durations.forEach(function (v) {
      variantStock[String(v.id)] = { stock: String(stock), duration: String(v.days), interval: 0, disabledDates: [], activeDays: false, timeSlots: false, disabledCalendar: false, prices: [{ days: 'default', price: 0 }] };
    });
    availPromise = fetch('https://izyrent.speaz.com/front/get_bookings', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: c.shop,
        idProduct: c.product.id,
        countLastRangeDay: 'duration',
        interval: { hours: false, stock: 'duration', variantStock: variantStock },
        timeRange: false,
        currentCarts: 'fb-wizard',
        // IzyRent soft-hold for open carts (minutes). Was 15; raised so Ansatt
        // betalingslenke / abandoned carts keep dates reserved longer.
        expiration: 7200, // 5 days
      }),
    }).then(function (r) { return r.json(); }).then(function (data) {
      var computed = computeOccupancy(data, stock);
      blocked = computed.blocked;
      occupancy = computed.occupancy;
      return blocked;
    }).catch(function () {
      blocked = new Set();
      occupancy = {};
      return blocked;
    });
    return availPromise;
  }

  function occupiedOn(k) {
    return (occupancy && occupancy[k]) || 0;
  }

  function remainingOn(k) {
    return Math.max(0, stockCount() - occupiedOn(k));
  }

  /* Fully booked for the requested qty (default 1). Fleet capacity is shared. */
  function isBlocked(k, qty) {
    var need = qty != null ? qty : (S && S.qty) || 1;
    if (!blocked && !occupancy) return false;
    return remainingOn(k) < need;
  }

  /* Max units still free across every day in [start, end] (inclusive). */
  function maxQtyForRange(start, end) {
    if (!start) return 1;
    var e = end || start;
    var minLeft = stockCount();
    for (var d = start; d <= e; d = addDays(d, 1)) {
      var left = remainingOn(d);
      if (left < minLeft) minLeft = left;
    }
    return Math.max(0, minLeft);
  }

  function clampQty() {
    if (!S) return;
    var max = S.start !== null ? maxQtyForRange(S.start, effEnd()) : stockCount();
    if (max < 1) max = 1;
    if (S.qty > max) {
      S.qty = max;
      S.notice = 'qty';
    }
    if (S.qty < 1) S.qty = 1;
  }

  /* Traffic-light level from remaining fleet capacity (transit counted in occupancy).
     - low:      <50% of units left  → "Få igjen"
     - waitlist: ≤10% of units left → "Opptatt med venteliste"
     - full:     not enough left for selected qty → "Opptatt" (blocked) */
  function dayLevel(k) {
    var need = (S && S.qty) || 1;
    if (isBlocked(k, need)) return 'full';
    var stock = stockCount();
    if (!stock || !occupancy) return 'ok';
    var used = occupancy[k] || 0;
    if (used <= 0) return 'ok';
    var leftRatio = (stock - used) / stock;
    if (leftRatio <= 0.1) return 'waitlist';
    if (leftRatio < 0.5) return 'low';
    return 'ok';
  }

  /* ---- weekend snapping (helg leies samlet fre–søn) ---- */
  function weekendBounds(k) {
    var fri = addDays(k, -(dow(k) - 4));
    return [fri, addDays(fri, 2)];
  }
  function snapToWeekend(a, b) {
    var s = a, e = b, snapped = false;
    if (isWeekend(s)) {
      var w1 = weekendBounds(s);
      if (w1[0] !== s || (a === b && w1[1] !== e)) snapped = true;
      s = w1[0];
      if (a === b && w1[1] > e) e = w1[1];
    }
    if (isWeekend(e)) {
      var w2 = weekendBounds(e);
      if (w2[1] !== e) snapped = true;
      e = w2[1];
    }
    return [s, e, snapped || s !== a || e !== b];
  }

  /* ---- Brreg (Brønnøysundregistrene) lookup for bedrift ---- */
  function titleCase(s) {
    return String(s || '').toLowerCase().replace(/(^|[\s\-])\S/g, function (c) { return c.toUpperCase(); });
  }

  /* Norwegian org numbers carry a mod-11 checksum in the 9th digit. */
  function orgnrValid(d) {
    if (!/^\d{9}$/.test(d)) return false;
    var w = [3, 2, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i < 8; i++) sum += +d[i] * w[i];
    var ctrl = 11 - (sum % 11);
    if (ctrl === 11) ctrl = 0;
    return ctrl !== 10 && ctrl === +d[8];
  }

  function fmtOrgnr(d) {
    return String(d || '').replace(/(\d{3})(?=\d)/g, '$1 ');
  }

  var brregSeq = 0;

  function brregStatusHtml() {
    if (!S || S.seg !== 'bedrift') return '';
    if (S.brregStatus === 'loading') return '<span class="fb-bw__helper">Slår opp i Brønnøysundregistrene…</span>';
    if (S.brregStatus === 'invalid') return '<span class="fb-bw__option-err">Ugyldig organisasjonsnummer — sjekk sifrene (9 siffer).</span>';
    if (S.brregStatus === 'notfound') return '<span class="fb-bw__option-err">Fant ikke organisasjonsnummeret i Brønnøysundregistrene.</span>';
    if (S.brregStatus === 'error') return '<span class="fb-bw__option-warn">Fikk ikke kontakt med Brønnøysundregistrene — fyll inn firmanavn manuelt.</span>';
    if (S.brregStatus === 'ok' && S.brreg) {
      var addr = [S.brreg.adresse, (S.brreg.postnr + ' ' + S.brreg.poststed).trim()].filter(Boolean).join(', ');
      return '<span class="fb-bw__brreg-ok">' + ICONS.check + '<span>' + esc(S.brreg.navn) + (addr ? ' · ' + esc(addr) : '') + '</span></span>';
    }
    return '';
  }

  function updateBrregUI() {
    var box = document.querySelector('[data-bw-brreg]');
    if (box) box.innerHTML = brregStatusHtml();
  }

  function brregLookup(orgnr) {
    var seq = ++brregSeq;
    S.brregStatus = 'loading';
    updateBrregUI();
    fetch('https://data.brreg.no/enhetsregisteret/api/enheter/' + orgnr)
      .then(function (r) {
        if (r.status === 404 || r.status === 410) return null;
        if (!r.ok) throw new Error('brreg');
        return r.json();
      })
      .then(function (data) {
        if (!S || seq !== brregSeq) return;
        if (!data) {
          S.brreg = null;
          S.brregStatus = 'notfound';
        } else {
          var addr = data.forretningsadresse || {};
          S.brreg = {
            navn: data.navn || '',
            adresse: (addr.adresse || []).join(', '),
            postnr: addr.postnummer || '',
            poststed: titleCase(addr.poststed),
          };
          S.brregStatus = 'ok';
          // Auto-fill the company name unless the user typed their own.
          if (S.brreg.navn && (!S.firma.trim() || S.firmaAuto)) {
            S.firma = S.brreg.navn;
            S.firmaAuto = true;
            var inp = document.getElementById('fb-bw-firma');
            if (inp) inp.value = S.firma;
          }
        }
        updateBrregUI();
        refreshFooterOnly();
      })
      .catch(function () {
        if (!S || seq !== brregSeq) return;
        S.brreg = null;
        S.brregStatus = 'error';
        updateBrregUI();
      });
  }

  function onOrgnrChanged() {
    S.brreg = null;
    if (S.orgnr.length < 9) {
      S.brregStatus = null;
      brregSeq++; // invalidate in-flight lookups
      updateBrregUI();
      return;
    }
    if (!orgnrValid(S.orgnr)) {
      S.brregStatus = 'invalid';
      brregSeq++;
      updateBrregUI();
      return;
    }
    brregLookup(S.orgnr);
  }

  /* ---- postnummer → poststed (for checkout prefill) ---- */
  var poststedCache = {};

  function lookupPoststed(postnr) {
    if (poststedCache[postnr] !== undefined) {
      if (S && S.postnr === postnr) S.poststed = poststedCache[postnr];
      return;
    }
    fetch('https://ws.geonorge.no/adresser/v1/sok?postnummer=' + postnr + '&treffPerSide=1')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var hit = data && data.adresser && data.adresser[0];
        poststedCache[postnr] = titleCase((hit && hit.poststed) || '');
        if (S && S.postnr === postnr) S.poststed = poststedCache[postnr];
      })
      .catch(function () {});
  }

  /* ---- delivery/region logic ---- */
  function regionOf(postnr) {
    if (!/^\d{4}$/.test(postnr)) return null;
    var n = parseInt(postnr, 10);
    if (Math.floor(n / 100) <= 13) return 'oslo';
    return [4, 5, 7].indexOf(Math.floor(n / 1000)) !== -1 ? 'storby' : 'distrikt';
  }
  var REGION_LABEL = { oslo: 'Oslo', storby: 'storby', distrikt: 'distrikt / lengre frakttid' };

  /* Freight sone 1 = Oslo (00xx–13xx), sone 2 = storby (4xxx/5xxx/7xxx). */
  function oppriggZoneOk(region) {
    return region === 'oslo' || region === 'storby';
  }
  function isOppriggAddon(a) {
    if (!a) return false;
    var handle = String(a.handle || '').toLowerCase();
    var title = String(a.title || '').toLowerCase();
    return handle === 'opp-nedrigg' || /opprigg|opp-?\s*&?\s*nedrigg/.test(title);
  }
  function oppriggAvailable() {
    return !!(S && S.seg === 'bedrift' && oppriggZoneOk(regionOf(S.postnr)));
  }
  function pruneUnavailableOpprigg() {
    if (!S) return;
    if (S.delivery === 'opprigg' && !oppriggAvailable()) S.delivery = null;
    var list = ((getConfig() && getConfig().addons) || []);
    list.forEach(function (a) {
      if (!isOppriggAddon(a)) return;
      delete S.addons[a.variantId];
    });
  }

  function deliveriesFor(region) {
    var c = getConfig();
    var list = [
      { id: 'posten', t: 'Posten / post i butikk', d: 'Hele Norge — gratis tur/retur', price: 0, retur: 4, lead: region === 'distrikt' ? 10 : 7, addr: true, icon: 'pkg', show: true },
    ];
    // CSV: Budbil Oslo = dagen før utsending. Oslo postnr only (00xx–13xx).
    if (c.budbil && region === 'oslo') {
      list.push({
        id: 'budbil',
        t: 'Budbil i Oslo',
        d: 'Levering til døra — bestill senest dagen før',
        price: c.budbil.price,
        retur: 1,
        lead: 1,
        addr: true,
        icon: 'truck',
        show: true,
        variantId: c.budbil.variantId,
      });
    }
    list.push({ id: 'henting', t: 'Hent / lever selv', d: c.pickupAddress || 'Oslo', price: 0, retur: 1, lead: 1, addr: false, icon: 'pin', show: region === 'oslo' });
    if (c.ekspress) {
      list.push({ id: 'ekspress', t: 'Posten Ekspress', d: 'Prioritert forsendelse', price: c.ekspress.price, retur: 4, lead: 2, addr: true, icon: 'truck', show: true, variantId: c.ekspress.variantId });
    }
    if (c.opprigg && S && S.seg === 'bedrift' && oppriggZoneOk(region)) {
      list.push({
        id: 'opprigg',
        t: 'Opprigg på ditt event',
        d: 'Vi rigger opp — nedrigg og retur gjør dere selv',
        price: c.opprigg.price,
        retur: 4,
        lead: region === 'oslo' ? 2 : 3,
        addr: true,
        icon: 'user',
        show: true,
        variantId: c.opprigg.variantId,
      });
    }
    return list.filter(function (x) { return x.show; });
  }

  /* ---- wizard state ---- */
  var S = null;

  function freshState(opts) {
    opts = opts || {};
    var seg = opts.seg || document.body.dataset.fbAudience || 'privat';
    if (seg !== 'bedrift') seg = 'privat';
    var start = null;
    var end = null;
    if (opts.date && !isBlocked(opts.date) && opts.date > todayKey()) {
      start = opts.date;
      if (isWeekend(start)) {
        var w = snapToWeekend(start, start);
        var ok = true;
        for (var d = w[0]; d <= w[1]; d = addDays(d, 1)) {
          if (isBlocked(d) || d <= todayKey()) ok = false;
        }
        if (ok) { start = w[0]; end = w[1]; }
      }
    }
    var occ = opts.occ || OCC[seg][0];
    if (OCC[seg].indexOf(occ) === -1) occ = OCC[seg][0];
    var state = {
      step: 0,
      maxStep: 0,
      seg: seg,
      occ: occ,
      packageKey: packageFromOpts(opts),
      packageTitle: opts.packageTitle || '',
      packagePrice: opts.packagePrice || '',
      start: start,
      end: end,
      qty: 1,
      notice: null,
      monthOffset: null,
      postnr: '',
      poststed: '',
      delivery: null,
      adresse: '',
      navn: '',
      epost: '',
      tlf: '',
      firma: '',
      firmaAuto: false,
      orgnr: '',
      brreg: null,
      brregStatus: null,
      payMethod: 'vipps',
      addons: {},
      addonsOpen: true,
      submitting: false,
      error: null,
      staffPin: '',
      staffBusy: false,
      staffErr: null,
      staffLink: null,
      staffName: '',
      staffCopied: false,
      staffOpen: false,
      fakturaDone: false,
      fakturaRef: '',
      fakturaTotalCents: null,
      // Rabattkode for bedriftsfaktura (Issue A, 25 Sep 2026). Validert av
      // Worker /discount-check (Shopify draftOrderCalculate) — aldri fritekst.
      rabattCode: '',
      rabatt: null, // { code, title, discountCents, totalCents, sig }
      rabattStatus: null, // null | 'checking' | 'invalid' | 'error'
      rabattMsg: '',
    };
    if (opts.occ && OCC[state.seg].indexOf(opts.occ) !== -1) state.occ = opts.occ;
    applyPackagePreset(state);
    if (opts.occ && OCC[state.seg].indexOf(opts.occ) !== -1) state.occ = opts.occ;
    return state;
  }

  /* ---- staff mode (telefonbooking) ----
     Shown on the payment step for everyone as a collapsed "Ansatt?" disclosure.
     ?ansatt=1 (or session) auto-expands it. PIN still required to create a link. */
  function staffFromUrl() {
    return /(?:[?&])ansatt=1(?:&|$)/.test(window.location.search);
  }
  function isStaff() {
    try {
      if (staffFromUrl()) {
        sessionStorage.setItem('fb-ansatt', '1');
        return true;
      }
      return sessionStorage.getItem('fb-ansatt') === '1';
    } catch (e) {
      return false;
    }
  }

  function staffOpen() {
    return !!(S && (S.staffOpen || S.staffLink || isStaff()));
  }

  /* Creates a Shopify draft order via the Make webhook.
     - staff: PIN required → Podio pending + Paymentlink
     - faktura: no PIN → Podio pending marked for EHF invoicing (no checkout) */
  /* Shopify tags are capped at 40 chars. pendingKey is also Podio external_id
     and order attribute — keep it unique but short enough that
     "fb-pending:" + key stays ≤ 40. */
  function pendingKeyFor(prefix) {
    var email = String(S.epost || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '').slice(0, 10);
    var day = String(S.start || '').replace(/-/g, '');
    var salt = Math.random().toString(36).slice(2, 6);
    return [prefix, email || 'x', day || '0', salt].join('-');
  }

  function pendingTag(pendingKey) {
    var tag = 'fb-pending:' + String(pendingKey || '');
    return tag.length <= 40 ? tag : tag.slice(0, 40);
  }

  function staffPendingKey() {
    return pendingKeyFor('tel');
  }

  function submitPendingDraft(opts) {
    var mode = opts && opts.mode === 'faktura' ? 'faktura' : 'staff';
    var isFaktura = mode === 'faktura';
    clampQty();
    if (S.start !== null && maxQtyForRange(S.start, effEnd()) < rentalQty()) {
      return Promise.reject(new Error('availability'));
    }
    var conf = getConfig();
    var hook = conf && conf.draftOrderUrl;
    if (!hook) return Promise.reject(new Error('webhook'));
    if (!isFaktura && !(S.staffPin || '').trim()) return Promise.reject(new Error('pin'));
    if (isFaktura && (S.seg !== 'bedrift' || !orgnrValid(S.orgnr) || !S.firma.trim())) {
      return Promise.reject(new Error('orgnr'));
    }

    var payload = buildOrderPayload();
    if (!payload) return Promise.reject(new Error('payload'));

    // Faktura drafts auto-complete til ordre i Make (Sep 2026). IzyRent
    // validerer fullførte ordre per linje, så qty≥2 splittes i N linjer à 1
    // (egen __izyrentValidation-ts per linje, Antall: '1'). get_discounts får
    // dermed N qty-1 cart-items, mens atc.quantity forblir N (rentalQty()).
    // Telefon-/checkout-stien er uendret — den valideres i kassen som før.
    if (isFaktura && rentalQty() >= 2) {
      var splitItems = [];
      payload.items.forEach(function (it) {
        if (!(it.properties && it.properties.__izyrentValidation) || it.quantity < 2) {
          splitItems.push(it);
          return;
        }
        for (var si = 0; si < it.quantity; si++) {
          var sp = {};
          Object.keys(it.properties).forEach(function (pk) { sp[pk] = it.properties[pk]; });
          sp.__izyrentValidation = (Date.now() + si) + ':1';
          sp.Antall = '1';
          splitItems.push({ id: it.id, quantity: 1, properties: sp });
        }
      });
      payload.items = splitItems;
    }

    var pendingKey = pendingKeyFor(isFaktura ? 'fak' : 'tel');
    var lineItems = payload.items.map(function (it) {
      var props = [];
      Object.keys(it.properties || {}).forEach(function (k) {
        props.push({ key: k, value: String(it.properties[k]) });
      });
      return {
        variantId: 'gid://shopify/ProductVariant/' + it.id,
        quantity: it.quantity,
        customAttributes: props,
      };
    });
    var customAttributes = [
      { key: 'Booking: pending-key', value: pendingKey },
      { key: 'Booking: kanal', value: isFaktura ? 'web-faktura' : 'telefon' },
    ];
    Object.keys(payload.attributes).forEach(function (k) {
      if (k === 'Booking: pending-key' || k === 'Booking: kanal') return;
      customAttributes.push({ key: k, value: String(payload.attributes[k] == null ? '' : payload.attributes[k]) });
    });

    var input = {
      email: S.epost.trim(),
      note: isFaktura
        ? 'Bedriftsfaktura (EHF) — kunde bestilte selv. Må faktureres manuelt.'
        : 'Telefonbooking — betalingslenke laget av ansatt i bookingveiviseren',
      tags: isFaktura
        ? ['bedriftsfaktura', 'fb-autopaid', pendingTag(pendingKey)]
        : ['telefonbooking', pendingTag(pendingKey)],
      customAttributes: customAttributes,
      lineItems: lineItems,
    };
    var name = S.navn.trim();
    var sp = name.lastIndexOf(' ');
    if (payload.d && payload.d.addr && S.adresse.trim()) {
      input.shippingAddress = {
        address1: S.adresse.trim(),
        zip: /^\d{4}$/.test(S.postnr) ? S.postnr : '',
        city: S.poststed || '',
        countryCode: 'NO',
        firstName: sp > 0 ? name.slice(0, sp) : name,
        lastName: sp > 0 ? name.slice(sp + 1) : '',
        phone: S.tlf.trim(),
      };
      if (S.seg === 'bedrift' && S.firma) input.shippingAddress.company = S.firma;
    }

    // Extra fields so Make can build a complete Podio item up front. Faktura
    // (EHF) never reaches the paid-order enrich in "Integration Shopify", so
    // everything staff needs must ride along here. Staff path gets the same
    // fields (harmless — enrich still runs on payment).
    var podioAddons = selectedAddons();
    var hasLogoAddon = podioAddons.some(function (a) {
      return /egen\s*logo|eget\s*logo|custom\s*logo/i.test(String(a.title || ''));
    });
    var linjer = [rentalQty() + ' x Fotobar Lite (' + ((payload.v && payload.v.title) || '') + ')'];
    if (payload.d && payload.d.t) linjer.push('1 x ' + payload.d.t);
    podioAddons.forEach(function (a) {
      linjer.push('1 x ' + a.title + ' (+' + money(a.price) + ')');
    });
    var podio = {
      pendingKey: pendingKey,
      fra: S.start,
      til: effEnd(),
      retur: addDays(effEnd(), 1),
      navn: S.navn.trim(),
      epost: S.epost.trim(),
      mobil: S.tlf.trim(),
      anledning: (S.seg === 'bedrift' ? 'Bedrift' : 'Privat') + ' / ' + S.occ,
      levering: payload.d ? payload.d.t : '',
      antall: rentalQty(),
      firma: S.firma || '',
      orgnr: S.orgnr ? fmtOrgnr(S.orgnr) : '',
      adresse: S.adresse.trim(),
      postnr: S.postnr || '',
      poststed: S.poststed || '',
      varighet: (payload.v && payload.v.title) || '',
      pakke: String(payload.attributes['Booking: pakke'] || ''),
      tilvalg: String(payload.attributes['Booking: tilvalg'] || ''),
      prisregler: String(payload.attributes['Booking: prisregler'] || ''),
      logo: hasLogoAddon ? 'custom' : 'standard',
      linjer: linjer.join(' | '),
    };

    // Rabattkode (Issue A): only the CODE rides along — Shopify validates and
    // prices it in draftOrderCreate (pre-validated via /discount-check).
    // Splice near the FRONT: Shopify silently drops TRAILING draft-order
    // customAttributes when the list is long (same quirk as leveringsmetode).
    if (isFaktura && S.rabatt && S.rabatt.code) {
      input.discountCodes = [S.rabatt.code];
      input.customAttributes.splice(2, 0, { key: 'Booking: rabattkode', value: S.rabatt.code });
      podio.rabatt = S.rabatt.code + ' (−' + money(S.rabatt.discountCents) + ')';
    }

    var settings = window.izyrentSettings || {};
    var izyCartToken = '';
    for (var ti = 0; ti < 32; ti++) izyCartToken += Math.floor(Math.random() * 16).toString(16);
    var rentalItems = payload.items.filter(function (it) {
      return it.properties && it.properties.__izyrentValidation;
    }).map(function (it) {
      return { variant_id: it.id, quantity: it.quantity, properties: it.properties };
    });

    return fetch('https://izyrent.speaz.com/front/get_discounts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: conf.shop,
        cart: {
          token: izyCartToken,
          deposit: settings.deposit && settings.deposit.id ? settings.deposit.id : undefined,
          items: rentalItems,
          atc: { product_id: conf.product.id, variant_id: payload.v.id, addons: '', date: payload.dateProp, quantity: rentalQty() },
        },
      }),
    }).then(function (r) {
      return r.json();
    }).catch(function () {
      return null;
    }).then(function (reg) {
      if (!reg || !reg.token || reg.token === 'unavailable') {
        throw new Error(reg && reg.token === 'unavailable' ? 'izyrent-unavailable' : 'izyrent');
      }
      input.customAttributes.splice(2, 0, { key: '__izyrentPrice', value: reg.token });
      var body = { input: JSON.stringify(input), podio: podio };
      if (isFaktura) body.kind = 'faktura';
      else body.pin = S.staffPin.trim();
      return fetch(hook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
    }).then(function (r) {
      return r.text();
    }).then(function (t) {
      var j = null;
      try { j = JSON.parse(t); } catch (e) {}
      if (!j) throw new Error(isFaktura ? 'webhook' : 'pin');
      if (!j.ok || !j.invoiceUrl) {
        var err = (j.errors && String(j.errors).trim()) || 'ukjent feil';
        throw new Error(err);
      }
      return j;
    });
  }

  function staffCreateLink() {
    if (S.staffBusy) return;
    S.error = null;
    S.staffBusy = true;
    S.staffErr = null;
    render();
    submitPendingDraft({ mode: 'staff' }).then(function (j) {
      S.staffBusy = false;
      S.staffLink = j.invoiceUrl;
      S.staffName = j.name || '';
      S.staffCopied = false;
      render();
    }).catch(function (err) {
      S.staffBusy = false;
      var msg = err && err.message;
      S.staffErr = msg === 'pin'
        ? 'Feil PIN — utkastet ble ikke laget.'
        : msg === 'availability'
          ? 'Ikke nok fotobarer ledige i perioden for valgt antall.'
          : msg === 'webhook'
            ? 'Webhook mangler i seksjonen — kjør scripts/setup-draft-order.mjs og publiser temaet.'
            : msg === 'izyrent-unavailable'
              ? 'IzyRent melder at datoen ikke er tilgjengelig.'
              : msg === 'izyrent'
                ? 'Fikk ikke registrert bookingen hos IzyRent — prøv igjen.'
                : 'Klarte ikke å lage betalingslenken: ' + (msg || 'ukjent feil');
      render();
    });
  }

  function finishFaktura() {
    if (S.submitting) return;
    S.submitting = true;
    S.error = null;
    render();
    submitPendingDraft({ mode: 'faktura' }).then(function (j) {
      S.submitting = false;
      S.fakturaDone = true;
      S.fakturaRef = j.name || '';
      // Shopify's own total (after rabattkode) from the Make respond.
      var t = parseFloat(j.total);
      S.fakturaTotalCents = isFinite(t) ? Math.round(t * 100) : null;
      try {
        localStorage.setItem('fb_min_booking_handoff', JSON.stringify({
          email: S.epost.trim(),
          url: (getConfig() && getConfig().minBookingUrl) || '/pages/min-booking',
          ts: Date.now(),
        }));
        sessionStorage.removeItem('fb_min_booking_handoff_hide');
        sessionStorage.removeItem('fb-tilvalg-booking');
      } catch (e) {}
      render();
    }).catch(function (err) {
      S.submitting = false;
      var msg = err && err.message;
      S.error = msg === 'availability'
        ? 'Ikke nok fotobarer ledige i perioden for valgt antall.'
        : msg === 'orgnr'
          ? 'Faktura krever gyldig firmanavn og org.nr.'
          : msg === 'webhook'
            ? 'Bestillingssystemet er midlertidig utilgjengelig. Prøv igjen, eller kontakt oss.'
            : msg === 'izyrent-unavailable'
              ? 'Datoen er ikke lenger ledig. Velg en annen periode.'
              : msg === 'izyrent'
                ? 'Fikk ikke registrert bookingen hos IzyRent — prøv igjen.'
                : 'Noe gikk galt ved fakturabestillingen. Prøv igjen — eller kontakt oss.';
      render();
    });
  }

  function effEnd() { return S.end === null ? S.start : S.end; }
  function rentalDays() { return S.start === null ? 0 : diffDays(S.start, effEnd()) + 1; }
  function rentalVariant() { return S.start === null ? null : variantForDays(rentalDays()); }
  /** Norwegian label for the billed Shopify duration variant (titles are English). */
  function durationLabelNo(variant) {
    if (!variant) return '';
    if (/helg/i.test(variant.title)) return 'Helg';
    var d = variant.days;
    if (d >= 365) return Math.round(d / 365) + ' år';
    if (d >= 30 && d % 30 === 0) {
      var months = d / 30;
      return months + ' måned' + (months === 1 ? '' : 'er');
    }
    if (d >= 7 && d % 7 === 0) {
      var weeks = d / 7;
      return weeks + ' uke' + (weeks === 1 ? '' : 'r');
    }
    return d + ' dag' + (d === 1 ? '' : 'er');
  }
  function delObj() {
    if (!S.delivery) return null;
    var region = regionOf(S.postnr);
    if (!region) return null;
    return deliveriesFor(region).find(function (x) { return x.id === S.delivery; }) || null;
  }
  function addonList() {
    var c = getConfig();
    var list = (c && c.addons) || [];
    // Opp/nedrigg etc. tagged bedrift-only — hide for privat.
    // AI green screen is sold as Del B / tilvalg upsell (AI-filter), not in the wizard.
    // Start-skjerm is not offered in Del A (removed from Bedriftspakken).
    return list.filter(function (a) {
      if (!a) return false;
      var title = String(a.title || '').toLowerCase();
      var handle = String(a.handle || '').toLowerCase();
      if (
        handle === 'ai-green-screen' ||
        /green\s*screen/.test(title) ||
        /green\s*screen/.test(handle) ||
        /\bai\s*green\b/.test(title)
      ) return false;
      if (
        handle === 'egen-profilert-start-skjerm' ||
        /profilert\s*start[\s-]*skjerm/.test(title) ||
        /profiled\s*start\s*screen/.test(title) ||
        /custom\s*\/?\s*profiled\s*start\s*screen/.test(title) ||
        /start[\s-]*skjerm/.test(handle)
      ) return false;
      if (isOppriggAddon(a)) {
        // Opprigg is a leveringsvalg only — never re-offer as tilvalg.
        return false;
      }
      var bedriftOnly = a.bedriftOnly === true ||
        (String(a.tags || '').toLowerCase().split('|').indexOf('bedrift') !== -1) ||
        (String(a.tags || '').toLowerCase().split('|').indexOf('bedrift-only') !== -1);
      if (bedriftOnly && S.seg !== 'bedrift') return false;
      return true;
    });
  }
  function selectedAddons() {
    return addonList().filter(function (a) { return S.addons[a.variantId]; });
  }

  /** Extra calendar days an addon adds on top of delivery lead (CSV: AI +2, egen logo +1).
      Prefer product tag `lead-N` / config.extraLeadDays; fall back to title heuristics. */
  function addonExtraLeadDays(a) {
    if (!a) return 0;
    if (typeof a.extraLeadDays === 'number' && a.extraLeadDays > 0) return a.extraLeadDays;
    var tags = String(a.tags || '').toLowerCase();
    var m = tags.match(/\blead-(\d+)\b/);
    if (m) return parseInt(m[1], 10) || 0;
    var t = String(a.title || '').toLowerCase();
    if (/ai[\s-]*filter|green\s*screen|skreddersydd\s*ai|standard\s*ai/.test(t)) return 2;
    if (/egen\s*logo|eget\s*logo|custom\s*logo/.test(t)) return 1;
    return 0;
  }

  function selectedAddonExtraLead() {
    return selectedAddons().reduce(function (max, a) {
      return Math.max(max, addonExtraLeadDays(a));
    }, 0);
  }

  /** Days needed before event for this addon given the chosen delivery method. */
  function addonRequiredLead(a) {
    var d = delObj();
    var base = d ? d.lead : 0;
    return base + addonExtraLeadDays(a);
  }

  function addonFeasible(a) {
    var du = daysUntil();
    var need = addonRequiredLead(a);
    if (du === null) return true;
    if (addonExtraLeadDays(a) <= 0) return true;
    return du >= need;
  }

  function rentalQty() {
    var n = S && parseInt(S.qty, 10);
    return n > 0 ? n : 1;
  }

  function rentalLineCents() {
    var v = rentalVariant();
    return (v ? v.price : 0) * rentalQty();
  }

  function totalCents() {
    var d = delObj();
    var extra = selectedAddons().reduce(function (sum, a) { return sum + a.price; }, 0);
    return rentalLineCents() + (d ? d.price : 0) + extra + priceRulesCents();
  }

  /* ---- rabattkode (bedriftsfaktura, Issue A 25 Sep 2026) ----
     Validated by the profrakt-shim Worker /discount-check endpoint, which
     runs Shopify draftOrderCalculate on the actual line items — the wizard
     never invents a price, it only relays what Shopify itself would grant. */
  function rabattActive() {
    return !!(S && S.payMethod === 'faktura' && S.rabatt);
  }
  function fakturaTotalCents() {
    return rabattActive() ? S.rabatt.totalCents : totalCents();
  }
  function rabattLines() {
    var payload = buildOrderPayload();
    if (!payload) return null;
    return payload.items.map(function (it) {
      return { variantId: String(it.id), quantity: it.quantity };
    });
  }
  function checkRabatt(silent) {
    var conf = getConfig();
    var url = conf && conf.discountCheckUrl;
    var code = String(S.rabattCode || '').trim();
    if (!url || !code || S.rabattStatus === 'checking') return;
    var lines = rabattLines();
    if (!lines || !lines.length) return;
    S.rabattStatus = 'checking';
    if (!silent) render();
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, lines: lines }),
    }).then(function (r) {
      return r.json();
    }).then(function (j) {
      if (j && j.ok && j.valid) {
        S.rabatt = {
          code: j.code,
          title: j.title || j.code,
          discountCents: j.discountCents || 0,
          totalCents: j.totalCents || totalCents(),
          sig: JSON.stringify(lines),
        };
        S.rabattStatus = null;
        S.rabattMsg = '';
      } else if (j && j.ok) {
        S.rabatt = null;
        S.rabattStatus = 'invalid';
        S.rabattMsg = j.message || 'Koden ble ikke gjenkjent — sjekk stavemåten.';
      } else {
        S.rabatt = null;
        S.rabattStatus = 'error';
        S.rabattMsg = 'Fikk ikke sjekket koden akkurat nå — prøv igjen.';
      }
      render();
    }).catch(function () {
      S.rabatt = null;
      S.rabattStatus = 'error';
      S.rabattMsg = 'Fikk ikke sjekket koden akkurat nå — prøv igjen.';
      render();
    });
  }
  function fmtRange() {
    if (S.start === null) return '';
    return effEnd() === S.start ? fmtDay(S.start) : fmtDay(S.start) + ' – ' + fmtDay(effEnd());
  }
  function daysUntil() {
    return S.start === null ? null : diffDays(todayKey(), S.start);
  }
  function contactOk() {
    return S.navn.trim() && /.+@.+\..+/.test(S.epost) && S.tlf.trim().length >= 8 && (S.seg !== 'bedrift' || (S.firma.trim() && orgnrValid(S.orgnr)));
  }
  function canNext() {
    var d = delObj();
    return [
      S.start !== null,
      true,
      !!d && (!d.addr || S.adresse.trim().length > 0),
      !!contactOk(),
      true,
    ][S.step];
  }

  /* ---- calendar picking ---- */
  function pick(k) {
    S.notice = null;
    var need = rentalQty();
    if (isBlocked(k, need) || k <= todayKey()) return;
    if (S.start !== null && S.end === null && k > S.start) {
      var r = snapToWeekend(S.start, k);
      var s = r[0], e = r[1], snapped = r[2];
      var ok = diffDays(s, e) < MAX_DAYS;
      var crosses = false;
      for (var d = s; d <= e; d = addDays(d, 1)) {
        if (isBlocked(d, need)) { crosses = true; ok = false; }
      }
      if (ok) {
        S.start = s;
        S.end = e;
        S.delivery = null;
        clampQty();
        if (snapped) S.notice = 'weekend';
        return;
      }
      if (crosses) S.notice = 'cross';
    }
    var r2 = snapToWeekend(k, k);
    var s2 = r2[0], e2 = r2[1];
    var bad = false;
    for (var d2 = s2; d2 <= e2; d2 = addDays(d2, 1)) {
      if (isBlocked(d2, need) || d2 <= todayKey()) bad = true;
    }
    if (s2 !== e2 && !bad) {
      S.start = s2;
      S.end = e2;
      S.notice = 'weekend';
    } else {
      S.start = k;
      S.end = null;
    }
    S.delivery = null;
    clampQty();
  }

  function setQty(n) {
    var next = parseInt(n, 10);
    if (!(next > 0)) next = 1;
    var max = S.start !== null ? maxQtyForRange(S.start, effEnd()) : stockCount();
    if (max < 1) max = 1;
    if (next > max) {
      S.qty = max;
      S.notice = 'qty';
    } else {
      S.qty = next;
      if (S.notice === 'qty') S.notice = null;
    }
  }

  /* ---- calendar rendering (shared) ---- */
  function renderCalendar(opts) {
    var now = new Date();
    var mi = new Date(now.getFullYear(), now.getMonth() + opts.monthOffset, 1);
    var monthLabel = MONTHS[mi.getMonth()] + ' ' + mi.getFullYear();
    var first = toKey(mi);
    var daysInMonth = new Date(mi.getFullYear(), mi.getMonth() + 1, 0).getDate();
    var lead = dow(first);

    var html = '<div class="fb-cal">';
    html += '<div class="fb-cal__head">';
    html += '<button type="button" class="fb-cal__nav" data-bw="cal-prev" ' + (opts.monthOffset <= 0 ? 'disabled' : '') + ' aria-label="Forrige måned">' + ICONS.chevL + '</button>';
    html += '<span class="fb-cal__month">' + esc(monthLabel) + '</span>';
    html += '<button type="button" class="fb-cal__nav" data-bw="cal-next" ' + (opts.monthOffset >= 23 ? 'disabled' : '') + ' aria-label="Neste måned">' + ICONS.chevR + '</button>';
    html += '</div>';
    html += '<div class="fb-cal__grid">';
    DOW_SHORT.forEach(function (d) { html += '<div class="fb-cal__dow">' + d + '</div>'; });
    // The class matters: the theme hides empty plain divs, which would
    // collapse the offset and shift every day under the wrong weekday column.
    for (var i = 0; i < lead; i++) html += '<div class="fb-cal__pad" aria-hidden="true"></div>';
    for (var day = 1; day <= daysInMonth; day++) {
      var k = toKey(new Date(mi.getFullYear(), mi.getMonth(), day));
      var past = k <= todayKey();
      var level = past ? 'past' : dayLevel(k);
      var booked = level === 'full';
      var sel = opts.start !== null && k >= opts.start && k <= (opts.end === null ? opts.start : opts.end);
      var cls = 'fb-cal__day';
      if (isWeekend(k) && !past && !booked && level === 'ok' && !sel) cls += ' is-weekend';
      if (past) cls += ' is-past';
      if (!past && level === 'full') cls += ' is-booked';
      else if (!past && level === 'waitlist') cls += ' is-waitlist';
      else if (!past && level === 'low') cls += ' is-low';
      if (sel) cls += ' is-selected';
      var title = past ? '' : level === 'full' ? 'Opptatt' : level === 'waitlist' ? 'Opptatt med venteliste' : level === 'low' ? 'Få igjen' : 'Ledig';
      html += '<button type="button" class="' + cls + '" data-bw="pick" data-day="' + k + '" ' + (past || booked ? 'disabled' : '') + ' title="' + title + '">' + day + '</button>';
    }
    html += '</div>';
    html += '<div class="fb-cal__legend">';
    html += '<span><span class="fb-cal__swatch" style="background: var(--coral-50); border: 1px solid var(--border-subtle);"></span> Helg (fre–søn) — leies samlet</span>';
    html += '<span><span class="fb-cal__swatch" style="background: #fff3cd;"></span> Få igjen</span>';
    html += '<span><span class="fb-cal__swatch" style="background: #ffe0c2;"></span> Opptatt med venteliste</span>';
    html += '<span><span class="fb-cal__swatch" style="background: #fdecea;"></span> Opptatt</span>';
    html += '</div></div>';
    return html;
  }

  /* ---- step rendering ---- */
  function renderStepper() {
    var html = '<div class="fb-bw__stepper">';
    STEPS.forEach(function (label, i) {
      var cls = 'fb-bw__step';
      if (i < S.step) cls += ' is-done';
      if (i === S.step) cls += ' is-active';
      if (i <= S.maxStep) cls += ' is-reachable';
      html += '<div class="' + cls + '">';
      if (i > 0) html += '<div class="fb-bw__step-line"></div>';
      html += '<button type="button" class="fb-bw__step-dot" data-bw="goto" data-step="' + i + '" ' + (i <= S.maxStep ? '' : 'disabled') + '>' + (i < S.step ? ICONS.check : (i + 1)) + '</button>';
      html += '<div class="fb-bw__step-label">' + label + '</div>';
      html += '</div>';
    });
    return html + '</div>';
  }

  function fmtDayWithDow(k) {
    return DOW_NAMES[dow(k)] + ' ' + fmtDay(k);
  }

  function renderRangeBar() {
    var fromVal = S.start !== null ? fmtDayWithDow(S.start) : null;
    var toVal = S.start !== null ? fmtDayWithDow(effEnd()) : null;
    var toPending = S.start !== null && S.end === null;
    var html = '<div class="fb-bw__range" aria-live="polite">';
    html += '<div class="fb-bw__range-box ' + (fromVal ? 'is-set' : '') + '">';
    html += '<span class="fb-bw__range-label">Fra</span>';
    html += '<span class="fb-bw__range-value">' + (fromVal ? esc(fromVal) : 'Velg dato i kalenderen') + '</span>';
    html += '</div>';
    html += '<span class="fb-bw__range-arrow" aria-hidden="true">' + ICONS.arrowR + '</span>';
    html += '<div class="fb-bw__range-box ' + (toVal ? 'is-set' : '') + '">';
    html += '<span class="fb-bw__range-label">Til</span>';
    html += '<span class="fb-bw__range-value">' + (toVal ? esc(toVal) : '—') + (toPending ? '<span class="fb-bw__range-hint"> · klikk siste dag for lengre leie</span>' : '') + '</span>';
    html += '</div>';
    html += '</div>';
    return html;
  }

  function renderQtyControl() {
    var max = S.start !== null ? maxQtyForRange(S.start, effEnd()) : stockCount();
    if (max < 1) max = 1;
    var qty = rentalQty();
    var html = '<div class="fb-bw__qty" role="group" aria-label="Antall fotobarer">';
    html += '<span class="fb-bw__qty-label">Antall fotobarer</span>';
    html += '<div class="fb-bw__qty-stepper">';
    html += '<button type="button" class="fb-bw__qty-btn" data-bw="qty-dec" ' + (qty <= 1 ? 'disabled' : '') + ' aria-label="Færre">−</button>';
    html += '<span class="fb-bw__qty-val" aria-live="polite">' + qty + '</span>';
    html += '<button type="button" class="fb-bw__qty-btn" data-bw="qty-inc" ' + (qty >= max ? 'disabled' : '') + ' aria-label="Flere">+</button>';
    html += '</div></div>';
    return html;
  }

  function renderStep0() {
    var html = '<div class="fb-bw__stack">';
    html += '<div><h2>Når er eventet?</h2><p class="fb-bw__sub" style="margin:0;">Se tilgjengelighet med en gang — velg én dag, eller klikk på siste dag for en periode.</p></div>';
    html += renderPackageBanner();
    html += renderCalendar({ monthOffset: S.monthOffset, start: S.start, end: S.end });
    html += renderRangeBar();
    if (S.notice === 'weekend') {
      html += '<div class="fb-bw__notice fb-bw__notice--coral">' + ICONS.cal + '<span>Helgen leies samlet (fredag–søndag), så valget ditt er utvidet til <strong>' + esc(fmtRange()) + '</strong>. Hele helgen er inkludert i prisen.</span></div>';
    }
    if (S.notice === 'cross') {
      html += '<div class="fb-bw__notice fb-bw__notice--yellow">' + ICONS.clock + '<span>Perioden krysser en opptatt dato, så vi startet et nytt valg. Velg en sammenhengende ledig periode.</span></div>';
    }
    if (S.start !== null && S.end === null && (S.notice === null || S.notice === 'qty')) {
      html += '<div class="fb-bw__notice fb-bw__notice--subtle">' + ICONS.cal + '<span>Flere dager? Klikk på siste dag også — dagene imellom velges automatisk (inntil 4 uker; helg leies samlet fre–søn).</span></div>';
    }
    if (S.start !== null) {
      html += renderQtyControl();
      var v = rentalVariant();
      var qty = rentalQty();
      html += '<div class="fb-bw__pricebox">';
      var spanLabel = (v && v.helg)
        ? 'helg fre–søn'
        : (rentalDays() + ' dag' + (rentalDays() > 1 ? 'er' : ''));
      html += '<div class="fb-bw__price-row"><span>Leie ' + esc(fmtRange()) + ' (' + spanLabel +
        (qty > 1 ? ' · ' + qty + ' fotobarer' : '') + ')</span><strong>' + money(rentalLineCents()) + '</strong></div>';
      if (qty > 1) {
        html += '<div class="fb-bw__price-row"><span style="color:var(--text-muted);">' + qty + ' × ' + money(v.price) + '</span><strong></strong></div>';
      }
      selectedAddons().forEach(function (a) {
        html += '<div class="fb-bw__price-row"><span>' + esc(a.title) + '</span><strong>+' + money(a.price) + '</strong></div>';
      });
      matchingPriceRules().forEach(function (r) {
        var sign = r.amount >= 0 ? '+' : '';
        html += '<div class="fb-bw__price-row"><span>' + esc(r.title) + '</span><strong>' + sign + money(r.amount) + '</strong></div>';
      });
      html += '<div class="fb-bw__price-total"><span style="font-weight:800;">' + (S.packageKey ? 'Pakkepris nå' : 'Leiepris') + '</span><span class="sum">' + money(totalCents()) + '</span></div>';
      html += '</div>';
      html += '<div class="fb-bw__notice fb-bw__notice--subtle">' + ICONS.check + '<span>Har du rabattkode eller avtalekode? Du legger den inn ved utsjekk i handlekurven — eller rett i betalingssteget her om du velger faktura (bedrift).</span></div>';
    }
    return html + '</div>';
  }

  function renderStep1() {
    var html = '<div class="fb-bw__stack">';
    html += '<div><h2>Hvem og hva feirer dere?</h2><p class="fb-bw__sub" style="margin:0;">Valget hjelper oss å tilpasse opplevelsen deres.</p></div>';
    html += renderPackageBanner();
    html += '<div class="fb-bw__seg">';
    [['privat', 'Privat'], ['bedrift', 'Bedrift']].forEach(function (p) {
      html += '<button type="button" class="' + (S.seg === p[0] ? 'is-on' : '') + '" data-bw="seg" data-value="' + p[0] + '">' + p[1] + '</button>';
    });
    html += '</div>';
    html += '<div class="fb-bw__chips">';
    OCC[S.seg].forEach(function (o) {
      html += '<button type="button" class="fb-bw__chip ' + (S.occ === o ? 'is-on' : '') + '" data-bw="occ" data-value="' + esc(o) + '">' + esc(o) + '</button>';
    });
    html += '</div>';
    html += '<div class="fb-bw__notice fb-bw__notice--subtle">' + ICONS.check + '<span>' + (S.seg === 'bedrift' ? 'Faktura tilbys som betaling (org.nr kreves). Bud på dør inngår i Bedriftspakken der det er tilgjengelig. Opp-/nedrigg er et dyrt tillegg — vi anbefaler selvbetjent oppsett.' : 'Privatbookinger forhåndsbetales trygt med Vipps, Klarna eller kort.') + '</span></div>';
    return html + '</div>';
  }

  function renderStep2() {
    preferPackageDelivery(S);
    var region = regionOf(S.postnr);
    var du = daysUntil();
    var html = '<div class="fb-bw__stack">';
    html += '<div><h2>Hvordan får du boksen?</h2><p class="fb-bw__sub" style="margin:0;">Postnummeret styrer utvalget — fristene beregnes per leveringsmetode.</p></div>';
    html += '<div style="display:flex; gap:10px; align-items:flex-end; flex-wrap:wrap;">';
    html += '<div class="fb-bw__field" style="max-width:180px;"><label class="fb-bw__label" for="fb-bw-postnr">Postnummer</label><input id="fb-bw-postnr" class="fb-bw__input" inputmode="numeric" maxlength="4" placeholder="0557" value="' + esc(S.postnr) + '" data-bw-input="postnr"></div>';
    if (region) html += '<span class="fb-bw__badge">Region: ' + esc(REGION_LABEL[region]) + '</span>';
    html += '</div>';
    if (region) {
      html += '<div class="fb-bw__options">';
      var addonLead = selectedAddonExtraLead();
      deliveriesFor(region).forEach(function (o) {
        var need = o.lead + addonLead;
        var feasible = du === null || du >= need;
        var margin = du === null ? null : du - need;
        var on = S.delivery === o.id;
        html += '<button type="button" class="fb-bw__option ' + (on ? 'is-on' : '') + '" data-bw="delivery" data-value="' + o.id + '" ' + (feasible ? '' : 'disabled') + '>';
        html += '<span style="color:' + (on ? 'var(--coral-600)' : 'var(--text-muted)') + '; flex-shrink:0;">' + ICONS[o.icon] + '</span>';
        html += '<span class="fb-bw__option-body">';
        html += '<span class="fb-bw__option-title">' + esc(o.t) + '</span>';
        html += '<span class="fb-bw__option-sub">' + esc(o.d) +
          (S.packageKey === 'bedrift' && o.id === 'budbil' ? ' · inkludert i Bedriftspakken' : '') +
          (o.id === 'opprigg' ? ' · kun bedrift i sone 1 og 2' : '') +
          (addonLead ? ' · +' + addonLead + ' dag' + (addonLead > 1 ? 'er' : '') + ' pga. tilvalg' : '') +
          '</span>';
        if (!feasible && du !== null) {
          html += '<span class="fb-bw__option-err">Krever bestilling ' + need + ' dager før event' +
            (addonLead ? ' (inkl. tilvalg)' : '') +
            ' — fristen for ' + esc(fmtDay(S.start)) + ' er passert</span>';
        }
        if (feasible && margin !== null && margin <= 2) {
          html += '<span class="fb-bw__option-warn">Frist: bestill innen ' + (margin === 0 ? 'i dag' : margin + ' dag' + (margin > 1 ? 'er' : '')) + '</span>';
        }
        html += '</span>';
        html += '<span class="fb-bw__option-price">' + (o.price === 0 ? 'Gratis' : '+' + money(o.price)) + '</span>';
        html += '</button>';
      });
      html += '</div>';
      var d = delObj();
      if (d && d.addr) {
        html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-adresse">Leveringsadresse</label>';
        html += '<div class="fb-addr"><input id="fb-bw-adresse" class="fb-bw__input" placeholder="Begynn å skrive gatenavn og nummer" value="' + esc(S.adresse) + '" data-bw-input="adresse" autocomplete="off"></div>';
        html += '<span class="fb-bw__helper">Velg fra listen (offisielle adresser fra Kartverket) — kan endres senere på Min booking.</span></div>';
      }
      if (d && d.id === 'opprigg') {
        html += '<div class="fb-bw__helper">Nedrigg gjør dere selv når eventet er over. Fest den inkluderte returlappen på esken og lever til nærmeste post i butikk.</div>';
      }
      if (d && !d.addr) {
        html += '<div class="fb-bw__helper">Adresse er ikke nødvendig for henting — hentetider kommer i bekreftelsen.</div>';
      }
    }
    return html + '</div>';
  }

  function renderStep3() {
    var html = '<div class="fb-bw__stack" style="gap:12px;">';
    html += '<div><h2>Kontaktinfo</h2><p class="fb-bw__sub" style="margin:0;">Bare det som trengs for å holde av datoen.</p></div>';
    html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-navn">Navn</label><input id="fb-bw-navn" class="fb-bw__input" placeholder="Ola Nordmann" autocomplete="name" value="' + esc(S.navn) + '" data-bw-input="navn"></div>';
    html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-epost">E-post</label><input id="fb-bw-epost" class="fb-bw__input" type="email" placeholder="ola@epost.no" autocomplete="email" value="' + esc(S.epost) + '" data-bw-input="epost"></div>';
    html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-tlf">Mobil</label><input id="fb-bw-tlf" class="fb-bw__input" type="tel" placeholder="900 00 000" autocomplete="tel" value="' + esc(S.tlf) + '" data-bw-input="tlf"></div>';
    if (S.seg === 'bedrift') {
      html += '<div class="fb-bw__grid2">';
      html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-orgnr">Org.nr (obligatorisk)</label><input id="fb-bw-orgnr" class="fb-bw__input" inputmode="numeric" maxlength="11" placeholder="912 345 678" value="' + esc(fmtOrgnr(S.orgnr)) + '" data-bw-input="orgnr"><span class="fb-bw__helper">Firmanavn hentes automatisk fra Brønnøysundregistrene.</span></div>';
      html += '<div class="fb-bw__field"><label class="fb-bw__label" for="fb-bw-firma">Firmanavn</label><input id="fb-bw-firma" class="fb-bw__input" placeholder="Bedrift AS" autocomplete="organization" value="' + esc(S.firma) + '" data-bw-input="firma"></div>';
      html += '</div>';
      html += '<div class="fb-bw__brreg" data-bw-brreg aria-live="polite">' + brregStatusHtml() + '</div>';
    }
    return html + '</div>';
  }

  /* Discreet, optional add-on picker ("bygge ut" bestillingen — bookingflyt A5).
     Products are curated by the team in the 'booking-tilvalg' collection.
     Addons with extra prep/delivery time (AI, egen logo) raise the lead vs event date. */
  function renderAddons() {
    var addons = addonList();
    if (!addons.length) return '';
    var sel = selectedAddons();
    var du = daysUntil();
    var d = delObj();
    var html = '<div class="fb-bw__addons ' + (S.addonsOpen ? 'is-open' : '') + '">';
    html += '<button type="button" class="fb-bw__addons-toggle" data-bw="addons-toggle" aria-expanded="' + (S.addonsOpen ? 'true' : 'false') + '">';
    html += '<span>Vil du legge til noe?<span class="fb-bw__addons-hint">Valgfritt</span></span>';
    html += '<span style="display:inline-flex; align-items:center; gap:8px;">' + (sel.length ? '<span class="fb-bw__addons-count">' + sel.length + ' valgt</span>' : '') + '<span class="fb-bw__addons-chev">' + ICONS.chevR + '</span></span>';
    html += '</button>';
    if (S.addonsOpen) {
      html += '<div class="fb-bw__addons-body">';
      addons.forEach(function (a) {
        var on = !!S.addons[a.variantId];
        var included = isPackageIncluded(a.variantId);
        var rec = a.tags && a.tags.indexOf(S.occ.toLowerCase()) !== -1;
        var extra = addonExtraLeadDays(a);
        var need = addonRequiredLead(a);
        var feasible = addonFeasible(a);
        html += '<div class="fb-bw__addon-block' + (!feasible && !on ? ' is-blocked' : '') + '">';
        html += '<button type="button" class="fb-bw__option ' + (on ? 'is-on' : '') + (!feasible && !on ? ' is-lead-blocked' : '') +
          (included ? ' is-package-included' : '') +
          '" data-bw="addon" data-value="' + a.variantId + '"' + (included ? ' aria-disabled="true"' : '') + '>';
        html += '<span class="fb-bw__check">' + (on ? ICONS.check : '') + '</span>';
        html += '<span class="fb-bw__option-body">';
        html += '<span class="fb-bw__option-title">' + esc(a.title) +
          (included ? '<span class="fb-bw__addon-badge">Inkludert i pakken</span>' :
            (rec ? '<span class="fb-bw__addon-badge">Anbefalt til ' + esc(S.occ.toLowerCase()) + '</span>' : '')) +
          '</span>';
        if (extra > 0) {
          html += '<span class="fb-bw__option-sub">Krever ' + extra + ' ekstra dag' + (extra > 1 ? 'er' : '') +
            ' produksjonstid' + (d ? ' (totalt ' + need + ' dager før event med valgt levering)' : '') +
            '</span>';
        }
        if (!feasible && du !== null && extra > 0 && !on) {
          html += '<span class="fb-bw__option-err">Rekker ikke til ' + esc(fmtDay(S.start)) +
            ' — trenger ' + need + ' dager med ' + esc(d ? d.t : 'valgt levering') +
            '. Bytt til raskere levering, eller hopp over tilvalget.</span>';
        }
        html += '</span>';
        html += '<span class="fb-bw__option-price">+' + money(a.price) + '</span>';
        html += '</button>';
        html += '</div>';
      });
      html += '<div class="fb-bw__helper" style="margin:0 2px;">Noen tilvalg (f.eks. AI-filter) trenger ekstra tid før utsending. Hvis datoen er for nær, bytt til raskere levering — eller hopp over tilvalget.</div>';
      html += '</div>';
    }
    html += '</div>';
    return html;
  }

  function renderStep4() {
    if (S.fakturaDone) {
      var minUrl = (getConfig() && getConfig().minBookingUrl) || '/pages/min-booking';
      var html = '<div class="fb-bw__stack" style="gap:16px;">';
      html += '<div class="fb-bw__notice" style="background:#ecfdf5; border-color:#a7f3d0;">' + ICONS.check +
        '<span><strong>Bestilling mottatt</strong> — vi sender EHF-faktura til bedriften din.</span></div>';
      html += '<div><h2>Takk for bestillingen</h2>';
      html += '<p class="fb-bw__sub" style="margin:0;">Datoen er reservert. Dere trenger ikke betale i kassen nå — faktura går via EHF.</p></div>';
      html += '<div class="fb-bw__summary">';
      html += '<div class="fb-bw__summary-row"><span>Referanse</span><span>' + esc(S.fakturaRef || '—') + '</span></div>';
      html += '<div class="fb-bw__summary-row"><span>Firma</span><span>' + esc(S.firma) + '</span></div>';
      html += '<div class="fb-bw__summary-row"><span>Org.nr</span><span>' + esc(fmtOrgnr(S.orgnr)) + '</span></div>';
      html += '<div class="fb-bw__summary-row"><span>Periode</span><span>' + esc(fmtRange()) + '</span></div>';
      if (S.rabatt) {
        html += '<div class="fb-bw__summary-row"><span>Rabattkode: ' + esc(S.rabatt.code) + '</span><span>−' + money(S.rabatt.discountCents) + '</span></div>';
      }
      html += '<div class="fb-bw__summary-row"><span>Totalt</span><span>' + money(S.fakturaTotalCents !== null ? S.fakturaTotalCents : fakturaTotalCents()) + '</span></div>';
      html += '</div>';
      html += '<p class="fb-bw__sub">Bekreftelse sendes til <strong>' + esc(S.epost) + '</strong>. Du kan følge bookingen på Min booking.</p>';
      html += '<a class="fb-bw__btn fb-bw__btn--primary" href="' + esc(minUrl) + '" style="text-align:center; text-decoration:none;">Gå til Min booking</a>';
      return html + '</div>';
    }
    var v = rentalVariant();
    var d = delObj();
    var html = '<div class="fb-bw__stack" style="gap:12px;">';
    html += '<div><h2>Fullfør reservasjonen</h2><p class="fb-bw__sub" style="margin:0;">Vipps/kort = betales nå. Faktura = EHF etter bestilling (ingen betaling i kassen).</p></div>';
    html += '<div class="fb-bw__summary">';
    if (S.packageKey) {
      html += '<div class="fb-bw__summary-row"><span>Pakke</span><span>' + esc(S.packageTitle || (getPackage(S.packageKey) || {}).title || S.packageKey) + '</span></div>';
    }
    html += '<div class="fb-bw__summary-row"><span>' + (S.seg === 'bedrift' ? 'Bedrift' : 'Privat') + ' · ' + esc(S.occ) + '</span><span>' + esc(fmtRange()) + '</span></div>';
    html += '<div class="fb-bw__summary-row"><span>Antall fotobarer</span><span>' + rentalQty() + '</span></div>';
    html += '<div class="fb-bw__summary-row"><span>Leie (' + esc(durationLabelNo(v)) +
      (rentalQty() > 1 ? ' · ' + rentalQty() + '×' : '') + ')</span><span>' + money(rentalLineCents()) + '</span></div>';
    html += '<div class="fb-bw__summary-row"><span>Levering: ' + esc(d ? d.t : '—') + '</span><span>' + (d ? (d.price === 0 ? 'Gratis' : '+' + money(d.price)) : '') + '</span></div>';
    selectedAddons().forEach(function (a) {
      html += '<div class="fb-bw__summary-row"><span>Tilvalg: ' + esc(a.title) + '</span><span>+' + money(a.price) + '</span></div>';
    });
    matchingPriceRules().forEach(function (r) {
      var sign = r.amount >= 0 ? '+' : '';
      html += '<div class="fb-bw__summary-row"><span>' + esc(r.title) + '</span><span>' + sign + money(r.amount) + '</span></div>';
    });
    if (rabattActive()) {
      html += '<div class="fb-bw__summary-row"><span>Rabattkode: ' + esc(S.rabatt.code) + '</span><span style="color:#059669;">−' + money(S.rabatt.discountCents) + '</span></div>';
    }
    html += '<div class="fb-bw__summary-row" style="border-top:1px solid var(--border-subtle); padding-top:8px;"><span style="font-weight:800; color:var(--text-strong);">Totalt</span><span style="font-weight:800; color:var(--coral-600); font-size:var(--text-lg);">' + money(fakturaTotalCents()) + '</span></div>';
    html += '</div>';
    html += renderAddons();
    html += '<div class="fb-bw__options">';
    [
      { id: 'vipps', t: 'Vipps hurtigkasse', d: 'Anbefalt — betal direkte med Vipps under', show: true },
      { id: 'kort', t: 'Kort eller Klarna', d: 'Trygg forhåndsbetaling', show: true },
      { id: 'faktura', t: 'Faktura (EHF)', d: 'Bedrift · vi sender faktura, ingen betaling i kassen', show: S.seg === 'bedrift' },
    ].filter(function (x) { return x.show; }).forEach(function (p) {
      var on = S.payMethod === p.id;
      html += '<button type="button" class="fb-bw__option ' + (on ? 'is-on' : '') + '" data-bw="pay" data-value="' + p.id + '">';
      html += '<span class="fb-bw__option-body"><span class="fb-bw__option-title">' + p.t + '</span><span class="fb-bw__option-sub">' + p.d + '</span></span>';
      html += '<span class="fb-bw__radio"></span>';
      html += '</button>';
    });
    html += '</div>';
    var conf4 = getConfig();
    if (S.payMethod === 'faktura' && conf4 && conf4.discountCheckUrl) {
      // Revalidate silently when the cart changed after a code was applied
      // (addon toggled, qty changed …) — amounts must track the real lines.
      if (S.rabatt && S.rabattStatus !== 'checking') {
        var curLines = rabattLines();
        if (curLines && JSON.stringify(curLines) !== S.rabatt.sig) checkRabatt(true);
      }
      html += rabattPanelHtml();
    }
    if (S.error) {
      html += '<div class="fb-bw__notice fb-bw__notice--yellow">' + ICONS.clock + '<span>' + esc(S.error) + '</span></div>';
    }
    html += staffPanelHtml();
    html += '<div class="fb-bw__trust"><span>' + ICONS.shield + ' Bindende reservasjon</span><span>' + ICONS.check + ' Gratis avbestilling til 4 uker før</span></div>';
    return html + '</div>';
  }

  function rabattPanelHtml() {
    var html = '<div class="fb-bw__field" style="margin:0;" data-fb-rabatt-panel>';
    html += '<label class="fb-bw__label" for="fb-bw-rabatt">Rabattkode (valgfritt)</label>';
    html += '<div style="display:flex; gap:8px;">';
    html += '<input id="fb-bw-rabatt" class="fb-bw__input" autocomplete="off" spellcheck="false" placeholder="Rabatt- eller avtalekode" value="' + esc(S.rabattCode) + '" data-bw-input="rabattCode" style="flex:1; min-width:0;">';
    html += '<button type="button" class="fb-bw__btn fb-bw__btn--secondary" style="flex-shrink:0; width:auto;" data-bw="rabatt-check" ' +
      (S.rabattStatus === 'checking' || !String(S.rabattCode || '').trim() ? 'disabled' : '') + '>' +
      (S.rabattStatus === 'checking' ? 'Sjekker…' : 'Bruk') + '</button>';
    html += '</div>';
    if (S.rabatt) {
      html += '<div class="fb-bw__notice" style="margin-top:8px; background:#ecfdf5; border-color:#a7f3d0;">' + ICONS.check +
        '<span>Koden <strong>' + esc(S.rabatt.code) + '</strong> er gyldig: −' + money(S.rabatt.discountCents) +
        '. Ny total: <strong>' + money(S.rabatt.totalCents) + '</strong>.</span></div>';
    } else if (S.rabattStatus === 'invalid' || S.rabattStatus === 'error') {
      html += '<div class="fb-bw__notice fb-bw__notice--yellow" style="margin-top:8px;">' + ICONS.clock + '<span>' + esc(S.rabattMsg) + '</span></div>';
    }
    return html + '</div>';
  }

  function staffPanelHtml() {
    if (!staffOpen()) {
      return '<p style="margin:12px 0 0; text-align:center;">' +
        '<button type="button" class="fb-bw__textbtn" data-bw="staff-open" style="font-size:0.85rem; font-weight:600; text-decoration:underline; background:none; border:0; cursor:pointer; color:var(--text-muted);">' +
        'Ansatt</button></p>';
    }
    var html = '<div style="margin-top:8px;">';
    if (S.staffLink) {
      html += '<div style="display:flex; gap:8px;">';
      html += '<input class="fb-bw__input" readonly value="' + esc(S.staffLink) + '" onclick="this.select()" style="flex:1; min-width:0; font-size:12px;">';
      html += '<button type="button" class="fb-bw__btn fb-bw__btn--secondary" style="flex-shrink:0; width:auto;" data-bw="staff-copy">' +
        (S.staffCopied ? 'Kopiert!' : 'Kopier') + '</button>';
      html += '</div>';
    } else {
      if (S.staffErr) {
        html += '<div class="fb-bw__notice fb-bw__notice--yellow" style="margin-bottom:10px;">' + ICONS.clock + '<span>' + esc(S.staffErr) + '</span></div>';
      }
      html += '<div style="display:flex; gap:8px; align-items:flex-end; flex-wrap:wrap;">';
      html += '<div class="fb-bw__field" style="margin:0; flex:0 0 150px;"><label class="fb-bw__label" for="fb-bw-staffpin">PIN</label>' +
        '<input id="fb-bw-staffpin" class="fb-bw__input" type="password" autocomplete="off" value="' + esc(S.staffPin) + '" data-bw-input="staffPin"></div>';
      html += '<button type="button" class="fb-bw__btn fb-bw__btn--primary" style="flex:1 1 220px;" data-bw="staff-link" ' +
        (S.staffBusy ? 'disabled' : '') + '>' + (S.staffBusy ? 'Lager lenke…' : 'Lag betalingslenke · ' + money(totalCents())) + '</button>';
      html += '</div>';
    }
    return html + '</div>';
  }

  function renderFooter() {
    var html = '<div class="fb-bw__footer">';
    if (S.fakturaDone) {
      html += '<div></div><div></div></div>';
      return html;
    }
    if (S.step > 0) html += '<button type="button" class="fb-bw__btn fb-bw__btn--secondary" data-bw="back">Tilbake</button>';
    html += '<div>';
    if (S.step < 4) {
      var labels = ['Neste: anledning', 'Neste: levering', 'Neste: kontaktinfo', 'Neste: betaling'];
      html += '<button type="button" class="fb-bw__btn fb-bw__btn--primary" data-bw="next" ' + (canNext() ? '' : 'disabled') + '>' + labels[S.step] + ' ' + ICONS.arrowR + '</button>';
    } else if (S.payMethod === 'vipps') {
      html += vippsWizardCtaHtml(S.submitting);
    } else if (S.payMethod === 'faktura') {
      var fakLabel = S.submitting
        ? 'Sender bestilling…'
        : 'Send bestilling · faktura · ' + money(fakturaTotalCents());
      html += '<button type="button" class="fb-bw__btn fb-bw__btn--primary" data-bw="finish" ' + (S.submitting ? 'disabled' : '') + '>' + fakLabel + '</button>';
    } else {
      var label = S.submitting
        ? 'Reserverer…'
        : 'Reserver og gå til betaling · ' + money(totalCents());
      html += '<button type="button" class="fb-bw__btn fb-bw__btn--primary" data-bw="finish" ' + (S.submitting ? 'disabled' : '') + '>' + label + '</button>';
    }
    html += '</div></div>';
    if (S.step > 0 && S.start !== null) {
      var v = rentalVariant();
      var d = delObj();
      html += '<div class="fb-bw__recap">' + esc(fmtRange()) +
        (rentalQty() > 1 ? ' · ' + rentalQty() + ' fotobarer' : '') +
        ' · ' + money(rentalLineCents()) + (d ? ' · ' + esc(d.t) : '') + '</div>';
    }
    return html;
  }

  function render() {
    var body = document.querySelector('[data-fb-bw-body]');
    if (!body || !S) return;
    if (blocked === null) {
      body.innerHTML = renderStepper() + '<div class="fb-bw__loading">Henter tilgjengelighet…</div>';
      return;
    }
    if (S.monthOffset === null) {
      var ref = S.start !== null ? fromKey(S.start) : new Date();
      var now = new Date();
      S.monthOffset = (ref.getFullYear() - now.getFullYear()) * 12 + (ref.getMonth() - now.getMonth());
    }
    var steps = [renderStep0, renderStep1, renderStep2, renderStep3, renderStep4];
    body.innerHTML = renderStepper() + steps[S.step]() + renderFooter();
    bindWizardAddressLookup();
  }

  function bindWizardAddressLookup() {
    var addr = document.getElementById('fb-bw-adresse');
    if (!addr || !window.FotobarenAddressLookup) return;
    window.FotobarenAddressLookup.bind(addr, {
      getPostnr: function () { return S && S.postnr; },
      onSelect: function (hit) {
        if (!S) return;
        var prevRegion = regionOf(S.postnr);
        S.adresse = hit.street;
        S.postnr = hit.postnr;
        S.poststed = hit.poststed;
        if (hit.postnr) poststedCache[hit.postnr] = hit.poststed;
        addr.value = hit.street;
        var pn = document.getElementById('fb-bw-postnr');
        if (pn) pn.value = hit.postnr;
        var region = regionOf(S.postnr);
        var stillOk = region && deliveriesFor(region).some(function (d) { return d.id === S.delivery; });
        if (prevRegion !== region || !stillOk) {
          pruneUnavailableOpprigg();
          if (!stillOk) S.delivery = null;
          preferPackageDelivery(S);
          render();
        } else {
          refreshFooterOnly();
        }
      },
    });
  }

  function refreshFooterOnly() {
    // avoid full re-render while typing (keeps input focus)
    var body = document.querySelector('[data-fb-bw-body]');
    if (!body) return;
    var btn = body.querySelector('[data-bw="next"]');
    if (btn) btn.disabled = !canNext();
  }

  /* ---- open/close ---- */
  function openWizard(opts) {
    var modal = document.getElementById('fb-booking-wizard');
    if (!modal || !getConfig()) return;
    S = freshState(opts);
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    render();
    fetchAvailability().then(function () {
      if (S && opts && opts.date && (isBlocked(opts.date) || opts.date <= todayKey())) S.start = null;
      render();
    });
  }

  function closeWizard() {
    var modal = document.getElementById('fb-booking-wizard');
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    S = null;
  }

  /* ---- checkout prefill via Storefront API buyer identity ----
     The theme's ajax cart is also a Storefront API cart, so we can attach the
     customer's email/phone/address to the cart itself before redirecting —
     checkout then prefills server-side. This is the supported route on every
     plan; the checkout[...] URL params below stay as a secondary fallback. */
  var SF_API = '/api/2026-04/graphql.json';

  function sfToken() {
    var c = getConfig();
    return (c && c.storefrontToken) || '';
  }

  function e164(tlf) {
    var t = String(tlf || '').replace(/[\s\-().]/g, '');
    if (/^\+\d{8,15}$/.test(t)) return t;
    if (/^00\d{8,15}$/.test(t)) return '+' + t.slice(2);
    if (/^\d{8}$/.test(t)) return '+47' + t;
    return null;
  }

  function sfMutation(query, variables) {
    return fetch(SF_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sfToken() },
      body: JSON.stringify({ query: query, variables: variables }),
    }).then(function (r) { return r.json(); });
  }

  /* Best effort: resolves within ~2.5s no matter what, so a slow or failing
     prefill can never block the redirect to checkout. */
  function prefillBuyerIdentity(cartToken, d) {
    if (!sfToken() || !cartToken) return Promise.resolve();
    var cartId = 'gid://shopify/Cart/' + cartToken;
    var phone = e164(S.tlf);
    var buyer = { email: S.epost.trim(), countryCode: 'NO' };
    if (phone) buyer.phone = phone;

    var work = sfMutation(
      'mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { userErrors { message } } }',
      { cartId: cartId, buyerIdentity: buyer }
    ).then(function () {
      if (!d || !d.addr || !S.adresse.trim()) return null;
      var name = S.navn.trim().replace(/\s+/g, ' ');
      var sp = name.lastIndexOf(' ');
      var addr = {
        lastName: sp > 0 ? name.slice(sp + 1) : name,
        address1: S.adresse.trim(),
        zip: S.postnr,
        countryCode: 'NO',
      };
      if (sp > 0) addr.firstName = name.slice(0, sp);
      if (S.poststed) addr.city = S.poststed;
      if (phone) addr.phone = phone;
      if (S.seg === 'bedrift' && S.firma.trim()) addr.company = S.firma.trim();
      return sfMutation(
        'mutation($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) { cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) { cart { id } userErrors { message } } }',
        { cartId: cartId, addresses: [{ selected: true, address: { deliveryAddress: addr } }] }
      );
    }).then(function () {
      // Checkout has a single free rate ("Levering valgt i booking") — select it.
      return sfMutation(
        'query ($cartId: ID!) { cart(id: $cartId) { deliveryGroups(first: 3) { edges { node { id deliveryOptions { handle title } } } } } }',
        { cartId: cartId }
      ).then(function (res) {
        var groups = (((res || {}).data || {}).cart || {}).deliveryGroups;
        var edges = (groups && groups.edges) || [];
        var pick = null;
        var groupId = null;
        edges.forEach(function (edge) {
          var node = edge && edge.node;
          if (!node || pick) return;
          var opts = node.deliveryOptions || [];
          var preferred = opts.find(function (opt) {
            return /levering valgt i booking/i.test(String(opt.title || ''));
          }) || opts[0];
          if (preferred) {
            pick = preferred.handle;
            groupId = node.id;
          }
        });
        if (!pick || !groupId) return;
        return sfMutation(
          'mutation ($cartId: ID!, $selectedDeliveryOptions: [CartSelectedDeliveryOptionInput!]!) { cartSelectedDeliveryOptionsUpdate(cartId: $cartId, selectedDeliveryOptions: $selectedDeliveryOptions) { userErrors { message } } }',
          { cartId: cartId, selectedDeliveryOptions: [{ deliveryGroupId: groupId, deliveryOptionHandle: pick }] }
        );
      });
    }).catch(function () {});

    return Promise.race([work, new Promise(function (res) { setTimeout(res, 3500); })]);
  }

  /* Prefill Shopify Checkout with what the customer already typed in the
     wizard, so nothing has to be entered twice. Shopify reads checkout[...]
     query params on the way into checkout and strips them from the final URL. */
  function checkoutPrefillQuery(d) {
    var qp = new URLSearchParams();
    var add = function (k, v) { if (v) qp.append(k, v); };
    var name = S.navn.trim().replace(/\s+/g, ' ');
    var sp = name.lastIndexOf(' ');
    add('checkout[email]', S.epost.trim());
    add('checkout[shipping_address][first_name]', sp > 0 ? name.slice(0, sp) : '');
    add('checkout[shipping_address][last_name]', sp > 0 ? name.slice(sp + 1) : name);
    add('checkout[shipping_address][phone]', S.tlf.trim());
    if (S.seg === 'bedrift') add('checkout[shipping_address][company]', S.firma.trim());
    if (d && d.addr) add('checkout[shipping_address][address1]', S.adresse.trim());
    if (/^\d{4}$/.test(S.postnr)) add('checkout[shipping_address][zip]', S.postnr);
    add('checkout[shipping_address][city]', S.poststed);
    add('checkout[shipping_address][country]', 'NO');
    return qp.toString();
  }

  /* ---- shared order payload (cart checkout + staff draft order) ---- */
  // Returns { v, d, items, attributes, dateProp } or null (renders the error itself).
  function buildOrderPayload() {
    var v = rentalVariant();
    var d = delObj();
    var returnDay = addDays(effEnd(), 1);
    var dateProp = fmtIzy(S.start) + ' kl. 10:00 til ' + fmtIzy(returnDay);

    if (!v || !v.id) {
      S.error = 'Helg-prisen mangler i butikken. Prøv igjen om litt, eller kontakt oss.';
      S.submitting = false;
      render();
      return null;
    }

    // Underscore-prefixed properties are hidden in cart/checkout but land on
    // the order — machine-readable ISO dates for the Podio integration.
    var items = [{
      id: v.id,
      quantity: rentalQty(),
      properties: {
        Date: dateProp,
        __izyrentValidation: Date.now() + ':' + rentalQty(),
        Anledning: S.occ,
        Segment: S.seg === 'bedrift' ? 'Bedrift' : 'Privat',
        Levering: d ? d.t : '',
        Antall: String(rentalQty()),
        _fra_iso: S.start,
        _til_iso: effEnd(),
        _retur_iso: returnDay,
      },
    }];
    if (d && d.variantId) {
      items.push({ id: d.variantId, quantity: 1, properties: { For: 'Fotobar-booking ' + fmtRange() } });
    }
    // Add-ons go after the rental item — the Make→Podio integration reads
    // duration/count from the FIRST line item, so the rental must stay first.
    var chosenAddons = selectedAddons();
    var tooSoon = chosenAddons.filter(function (a) { return !addonFeasible(a); });
    if (tooSoon.length) {
      tooSoon.forEach(function (a) { delete S.addons[a.variantId]; });
      S.error = tooSoon[0].title + ' rekker ikke til ' + fmtDay(S.start) +
        '. Bytt levering, eller fortsett uten tilvalget.';
      S.submitting = false;
      S.addonsOpen = true;
      render();
      return null;
    }
    chosenAddons.forEach(function (a) {
      if (d && d.variantId && String(a.variantId) === String(d.variantId)) return;
      var props = { For: 'Fotobar-booking ' + fmtRange() };
      if (isPackageIncluded(a.variantId)) {
        props.Pakke = S.packageTitle || (getPackage(S.packageKey) || {}).title || S.packageKey;
      }
      items.push({ id: a.variantId, quantity: 1, properties: props });
    });

    // Peak / demand surcharges — separate products so rental stays first line for Make/Podio.
    var priceHits = matchingPriceRules();
    var surchargeLabels = [];
    priceHits.forEach(function (r) {
      if (r.amount > 0 && r.variantId) {
        items.push({
          id: r.variantId,
          quantity: 1,
          properties: {
            For: 'Fotobar-booking ' + fmtRange(),
            Prisregel: r.title,
            _prisregel: r.key,
          },
        });
      }
      if (r.amount) {
        surchargeLabels.push(r.title + ' (' + (r.amount >= 0 ? '+' : '') + money(r.amount) + ')');
      }
    });

    var attributes = {
      'Booking: fra': S.start,
      'Booking: til': effEnd(),
      'Booking: retur': returnDay,
      'Booking: navn': S.navn,
      'Booking: e-post': S.epost,
      'Booking: mobil': S.tlf,
      'Booking: postnummer': S.postnr,
      'Booking: leveringsadresse': S.adresse,
      'Booking: leveringsmetode': d ? d.t : '',
      'Booking: anledning': (S.seg === 'bedrift' ? 'Bedrift' : 'Privat') + ' / ' + S.occ,
      'Booking: ønsket betaling': S.payMethod,
      'Booking: antall': String(rentalQty()),
      // Clear leftover Min-booking / tilvalg cart attrs. Shopify keeps cart
      // attributes across /cart/clear.js; if type=tilvalg survives, Make routes
      // the new rental to the linked booking instead of creating a new one.
      // Use a non-empty value: Shopify drops empty-string attributes, and Make's
      // text:notequal filter then fails to match the Fotobar-booking route.
      'Booking: type': 'fotobar',
      'Booking: linked-order': '',
    };
    if (S.seg === 'bedrift') {
      attributes['Booking: firma'] = S.firma;
      attributes['Booking: org.nr'] = fmtOrgnr(S.orgnr);
      if (S.brreg) {
        var brregAddr = [S.brreg.adresse, (S.brreg.postnr + ' ' + S.brreg.poststed).trim()].filter(Boolean).join(', ');
        if (brregAddr) attributes['Booking: firmaadresse'] = brregAddr;
      }
    }
    if (S.packageKey) {
      attributes['Booking: pakke'] = S.packageTitle || (getPackage(S.packageKey) || {}).title || S.packageKey;
    }
    if (surchargeLabels.length) {
      attributes['Booking: prisregler'] = surchargeLabels.join('; ');
    }
    var minBooking = (getConfig() && getConfig().minBookingUrl) || '/pages/min-booking';
    attributes['Min reservasjon'] = minBooking;
    attributes['Neste steg'] = S.payMethod === 'faktura'
      ? 'Vi sender EHF-faktura. Se og fullfør bookingen på Min booking.'
      : 'Se, fullfør og endre reservasjonen på Min booking etter betaling.';
    if (chosenAddons.length) {
      attributes['Booking: tilvalg'] = chosenAddons.map(function (a) { return a.title + ' (+' + money(a.price) + ')'; }).join('; ');
    }

    return { v: v, d: d, items: items, attributes: attributes, dateProp: dateProp };
  }

  /* Vipps express from booking wizard (no cart-drawer hop).
     Do NOT put Vipps’ .vipps-button-item markup on the wizard CTA — their
     capture-phase listener fires before finish() builds the cart and shows
     “No items to purchase”. After the cart is ready we refresh the drawer
     (closed) and click the real Liquid Vipps button there. */
  function openVippsExpress() {
    var cartFetch = window.__nativeFetch || window.fetch.bind(window);
    return cartFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.item_count) throw new Error('empty');

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: false },
        }));

        return new Promise(function (resolve) {
          var tries = 0;
          function attempt() {
            tries += 1;
            var target = document.querySelector('#CartDrawer .vipps-brand-vipps .vipps-btn')
              || document.querySelector('#CartDrawer .vipps-brand-vipps');

            if (target) {
              try {
                target.click();
                resolve(true);
                return;
              } catch (e) {}
            }

            if (tries < 30) {
              setTimeout(attempt, 200);
              return;
            }
            resolve(false);
          }
          setTimeout(attempt, 450);
        });
      })
      .catch(function () {
        return false;
      });
  }

  var VIPPS_LOGO_SVG =
    '<svg class="fb-bw__vipps-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 16" fill="none" aria-hidden="true">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M64 3.83839C63.2798 1.09068 61.5314 0 59.1447 0C57.2111 0 54.7842 1.09068 54.7842 3.71715C54.7842 5.41401 55.9565 6.7476 57.8694 7.09117L59.6797 7.41418C60.9142 7.63629 61.2639 8.1011 61.2639 8.72741C61.2639 9.43447 60.5027 9.83844 59.3713 9.83844C57.8904 9.83844 56.9646 9.31324 56.8205 7.83828L54.2081 8.24247C54.6193 11.0908 57.17 12.2629 59.4739 12.2629C61.6547 12.2629 63.9792 11.0101 63.9792 8.48494C63.9792 6.76751 62.9298 5.51533 60.9756 5.15119L58.9805 4.78792C57.8694 4.58593 57.4993 4.04038 57.4993 3.51517C57.4993 2.84837 58.2191 2.42449 59.2066 2.42449C60.4616 2.42449 61.3461 2.84837 61.3872 4.24236L64 3.83839ZM5.925 8.16128L8.6399 0.302869H11.8283L7.09686 11.9594H4.73146L0 0.303088H3.18843L5.925 8.16128ZM22.6084 3.6364C22.6084 4.56558 21.8678 5.21202 21.0037 5.21202C20.1397 5.21202 19.3994 4.56558 19.3994 3.6364C19.3994 2.70701 20.1397 2.06078 21.0037 2.06078C21.8678 2.06078 22.6086 2.70701 22.6086 3.6364H22.6084ZM23.102 7.75775C22.0321 9.13112 20.9007 10.0806 18.9053 10.0807C16.8693 10.0807 15.2849 8.86856 14.0507 7.09095C13.5568 6.36354 12.7957 6.20204 12.2402 6.58588C11.726 6.94959 11.6028 7.71726 12.0757 8.38406C13.783 10.9497 16.1486 12.4443 18.9051 12.4443C21.4356 12.4443 23.4106 11.2324 24.9532 9.21214C25.5291 8.46481 25.5085 7.69713 24.9532 7.27281C24.4388 6.8684 23.6777 7.01042 23.102 7.75775ZM30.2 6.10094C30.2 8.48494 31.5989 9.73756 33.1625 9.73756C34.6434 9.73756 36.1659 8.56569 36.1659 6.10094C36.1659 3.67645 34.6434 2.50502 33.1828 2.50502C31.5989 2.50502 30.2 3.61605 30.2 6.10094ZM30.2 1.91941V0.323002H27.2996V16H30.2V10.424C31.1669 11.7172 32.4217 12.2629 33.8409 12.2629C36.495 12.2629 39.0868 10.2022 39.0868 5.95979C39.0868 1.89884 36.392 0.000218868 34.0879 0.000218868C32.257 0.000218868 31.0024 0.828296 30.2 1.91941ZM44.1275 6.10094C44.1275 8.48494 45.5262 9.73756 47.0898 9.73756C48.5707 9.73756 50.093 8.56569 50.093 6.10094C50.093 3.67645 48.5707 2.50502 47.1102 2.50502C45.5262 2.50502 44.1273 3.61605 44.1273 6.10094H44.1275ZM44.1275 1.91941V0.323002H44.1273H41.2269V16H44.1273V10.424C45.0943 11.7172 46.349 12.2629 47.7683 12.2629C50.4222 12.2629 53.0141 10.2022 53.0141 5.95979C53.0141 1.89884 50.3194 0.000218868 48.0152 0.000218868C46.1843 0.000218868 44.9298 0.828296 44.1275 1.91941Z" fill="currentColor"/></svg>';

  function vippsWizardCtaHtml(busy) {
    var label = busy ? 'Reserverer…' : 'Betal med';
    // Own markup only — Vipps app listens for .vipps-button-item in capture phase.
    return (
      '<div class="fb-bw__vipps-cta" id="fb-bw-vipps">' +
        '<button type="button" class="fb-bw__vipps-btn" data-bw="finish"' +
          (busy ? ' disabled' : '') + '>' +
          '<span class="fb-bw__vipps-btn-text">' + label + '</span>' +
          VIPPS_LOGO_SVG +
        '</button>' +
      '</div>'
    );
  }

  /* ---- finish: add to cart with IzyRent-compatible properties ---- */
  function finish() {
    if (S.submitting || S.fakturaDone) return;
    if (S.payMethod === 'faktura') {
      finishFaktura();
      return;
    }
    clampQty();
    if (S.start !== null && maxQtyForRange(S.start, effEnd()) < rentalQty()) {
      S.error = 'Det er ikke nok fotobarer ledige i den valgte perioden. Reduser antall eller velg andre datoer.';
      S.step = 0;
      render();
      return;
    }
    S.submitting = true;
    S.error = null;
    render();

    var payload = buildOrderPayload();
    if (!payload) return;
    var v = payload.v;
    var d = payload.d;
    var items = payload.items;
    var attributes = payload.attributes;
    var dateProp = payload.dateProp;

    var cartToken = null;

    // Replace cart contents: abandoned checkouts leave rental/delivery/tilvalg
    // lines behind, and a second "Fullfør" would otherwise stack duplicates.
    // "?izyrent" makes IzyRent's patched fetch leave these calls alone.
    fetch('/cart/clear.js?izyrent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }).then(function (r) {
      if (!r.ok) throw new Error('clear');
      return fetch('/cart/add.js?izyrent', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return fetch('/cart.js?izyrent').then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      cartToken = cart.token;
      // Register the booking with IzyRent's backend. It returns an encoded
      // token that must live in the __izyrentPrice cart attribute — their
      // checkout validation rejects rental items without it ("Expired dates").
      var settings = window.izyrentSettings || {};
      var rentalItems = cart.items.filter(function (i) {
        return i.properties && i.properties.__izyrentValidation;
      }).map(function (i) {
        return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties };
      });
      return fetch('https://izyrent.speaz.com/front/get_discounts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: getConfig().shop,
          cart: {
            token: cart.token,
            deposit: settings.deposit && settings.deposit.id ? settings.deposit.id : undefined,
            items: rentalItems,
            atc: { product_id: getConfig().product.id, variant_id: v.id, addons: '', date: dateProp, quantity: rentalQty() },
          },
        }),
      }).then(function (r3) { return r3.json(); }).catch(function () { return null; });
    }).then(function (reg) {
      if (reg && reg.token && reg.token !== 'unavailable') {
        attributes.__izyrentPrice = reg.token;
      }
      return Promise.all([
        fetch('/cart/update.js?izyrent', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes }),
        }),
        prefillBuyerIdentity(cartToken, d),
      ]).then(function (results) { return results[0]; });
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      try {
        localStorage.setItem('fb_min_booking_handoff', JSON.stringify({
          email: S.epost.trim(),
          url: (getConfig() && getConfig().minBookingUrl) || '/pages/min-booking',
          ts: Date.now(),
        }));
        sessionStorage.removeItem('fb_min_booking_handoff_hide');
        sessionStorage.removeItem('fb-tilvalg-booking');
      } catch (e) {}

      if (S.payMethod === 'vipps') {
        S.submitting = false;
        render();
        return openVippsExpress().then(function (ok) {
          if (!ok) {
            S.error = 'Vipps var ikke klar. Prøv igjen, eller velg kort/Klarna.';
            render();
          }
        });
      }

      // /cart/checkout is the path Shopify supports for checkout[...] prefill.
      window.location.href = '/cart/checkout?' + checkoutPrefillQuery(d);
    }).catch(function () {
      S.submitting = false;
      S.error = 'Noe gikk galt ved reservasjonen. Prøv igjen — eller kontakt oss, så hjelper vi deg.';
      render();
    });
  }

  /* ---- events ---- */
  function bindWizard() {
    var modal = document.getElementById('fb-booking-wizard');
    if (!modal) return;

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fb-bw-close]')) { closeWizard(); return; }
      var el = e.target.closest('[data-bw]');
      if (!el || !S) return;
      var action = el.dataset.bw;
      if (action === 'pick') { pick(el.dataset.day); render(); }
      else if (action === 'qty-inc') { setQty(rentalQty() + 1); render(); }
      else if (action === 'qty-dec') { setQty(rentalQty() - 1); render(); }
      else if (action === 'cal-prev') { S.monthOffset = Math.max(0, S.monthOffset - 1); render(); }
      else if (action === 'cal-next') { S.monthOffset = Math.min(23, S.monthOffset + 1); render(); }
      else if (action === 'goto') { var i = +el.dataset.step; if (i <= S.maxStep) { S.step = i; render(); } }
      else if (action === 'back') { S.step = Math.max(0, S.step - 1); render(); }
      else if (action === 'next') { if (canNext()) { S.step += 1; S.maxStep = Math.max(S.maxStep, S.step); render(); } }
      else if (action === 'seg') {
        S.seg = el.dataset.value;
        S.occ = OCC[S.seg][0];
        S.payMethod = 'vipps';
        if (S.packageKey && getPackage(S.packageKey) && getPackage(S.packageKey).seg !== S.seg) {
          S.packageKey = '';
          S.packageTitle = '';
          S.packagePrice = '';
          S.addons = {};
        }
        pruneUnavailableOpprigg();
        render();
      }
      else if (action === 'delivery') {
        S.delivery = el.dataset.value;
        pruneUnavailableOpprigg();
        render();
      }
      else if (action === 'occ') { S.occ = el.dataset.value; render(); }
      else if (action === 'pay') { S.payMethod = el.dataset.value; render(); }
      else if (action === 'addons-toggle') { S.addonsOpen = !S.addonsOpen; render(); }
      else if (action === 'addon') {
        var aid = el.dataset.value;
        if (isPackageIncluded(aid)) {
          S.error = null;
          return;
        }
        if (S.addons[aid]) {
          delete S.addons[aid];
          S.error = null;
        } else {
          var addon = addonList().find(function (a) { return String(a.variantId) === String(aid); });
          if (addon && !addonFeasible(addon)) {
            S.addonsOpen = true;
            S.error = addon.title + ' rekker ikke til ' + fmtDay(S.start) +
              '. Bytt til raskere levering, eller hopp over tilvalget.';
            render();
            return;
          }
          S.addons[aid] = true;
          S.error = null;
        }
        render();
      }
      else if (action === 'finish') { finish(); }
      else if (action === 'rabatt-check') { checkRabatt(); }
      else if (action === 'staff-open') { S.staffOpen = true; render(); }
      else if (action === 'staff-close') { S.staffOpen = false; render(); }
      else if (action === 'staff-link') { staffCreateLink(); }
      else if (action === 'staff-copy') {
        try {
          navigator.clipboard.writeText(S.staffLink).then(function () {
            S.staffCopied = true;
            render();
          });
        } catch (err) {}
      }
    });

    modal.addEventListener('input', function (e) {
      var el = e.target.closest('[data-bw-input]');
      if (!el || !S) return;
      var key = el.dataset.bwInput;
      if (key === 'postnr') {
        var val = el.value.replace(/\D/g, '').slice(0, 4);
        var prevRegion = regionOf(S.postnr);
        S.postnr = val;
        S.poststed = '';
        el.value = val;
        if (/^\d{4}$/.test(val)) lookupPoststed(val);
        var region = regionOf(val);
        if (prevRegion !== region) {
          pruneUnavailableOpprigg();
          if (S.delivery && (!region || !deliveriesFor(region).some(function (d) { return d.id === S.delivery; }))) {
            S.delivery = null;
          }
          preferPackageDelivery(S);
          render();
          var inp = document.getElementById('fb-bw-postnr');
          if (inp) { inp.focus(); inp.setSelectionRange(val.length, val.length); }
        }
        else refreshFooterOnly();
      } else if (key === 'orgnr') {
        var digits = el.value.replace(/\D/g, '').slice(0, 9);
        var changed = digits !== S.orgnr;
        S.orgnr = digits;
        el.value = fmtOrgnr(digits);
        if (changed) onOrgnrChanged();
        refreshFooterOnly();
      } else if (key === 'rabattCode') {
        var rv = el.value;
        var hadState = !!S.rabatt || !!S.rabattStatus;
        S.rabattCode = rv;
        if (S.rabatt && rv.trim().toLowerCase() !== String(S.rabatt.code).toLowerCase()) S.rabatt = null;
        S.rabattStatus = null;
        S.rabattMsg = '';
        if (hadState) {
          render();
          var ri = document.getElementById('fb-bw-rabatt');
          if (ri) { ri.focus(); ri.setSelectionRange(rv.length, rv.length); }
        } else {
          var rb = document.querySelector('[data-bw="rabatt-check"]');
          if (rb) rb.disabled = !rv.trim();
          refreshFooterOnly();
        }
      } else {
        if (key === 'firma') S.firmaAuto = false;
        S[key] = el.value;
        refreshFooterOnly();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeWizard();
    });
  }

  function bindTriggers() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="#fb-booking"], [data-fb-open-booking]');
      if (!link) return;
      if (!document.getElementById('fb-booking-wizard')) return;
      e.preventDefault();
      openWizard({
        date: link.dataset.fbBookingDate || null,
        seg: link.dataset.fbBookingSeg || null,
        occ: link.dataset.fbBookingOcc || null,
        packageKey: link.dataset.fbBookingPackage || '',
        packageTitle: link.dataset.fbBookingPackageTitle || '',
        packagePrice: link.dataset.fbBookingPackagePrice || '',
      });
    });
  }

  /* ---- inline availability calendar on rental product pages ---- */
  var inlineState = { monthOffset: 0, selected: null };

  function renderInline() {
    var mount = document.querySelector('[data-fb-avail-inline]');
    if (!mount) return;
    var html = '<div class="fb-avail-inline">';
    html += '<div class="fb-avail-inline__head">';
    html += '<div class="fb-avail-inline__title">' + ICONS.cal + ' Ledige datoer</div>';
    html += '</div>';
    if (blocked === null) {
      html += '<div class="fb-bw__loading">Henter tilgjengelighet…</div>';
    } else {
      html += renderCalendar({ monthOffset: inlineState.monthOffset, start: inlineState.selected, end: null });
    }
    html += '</div>';
    html += '<div class="fb-avail-inline__actions">';
    var label = inlineState.selected ? 'Reserver ' + esc(fmtDay(inlineState.selected)) : 'Reserver dato';
    html += '<button type="button" class="fb-bw__btn fb-bw__btn--primary" style="width:auto; flex:1 1 auto; max-width:340px;" data-fb-open-booking ' + (inlineState.selected ? 'data-fb-booking-date="' + inlineState.selected + '"' : '') + '>' + label + ' ' + ICONS.arrowR + '</button>';
    html += '</div>';
    mount.innerHTML = html;
  }

  function bindInline() {
    var mount = document.querySelector('[data-fb-avail-inline]');
    if (!mount || !getConfig()) return;
    if (mount.dataset.fbHandle && mount.dataset.fbHandle !== getConfig().product.handle) return;

    mount.addEventListener('click', function (e) {
      var el = e.target.closest('[data-bw]');
      if (!el) return;
      e.stopPropagation();
      var action = el.dataset.bw;
      if (action === 'cal-prev') { inlineState.monthOffset = Math.max(0, inlineState.monthOffset - 1); renderInline(); }
      else if (action === 'cal-next') { inlineState.monthOffset = Math.min(23, inlineState.monthOffset + 1); renderInline(); }
      else if (action === 'pick') { inlineState.selected = el.dataset.day; renderInline(); }
    }, true);

    renderInline();
    fetchAvailability().then(renderInline);
  }

  function init() {
    if (!getConfig()) return;
    bindWizard();
    bindTriggers();
    bindInline();
    // Staff shortcut: /?ansatt=1 or /pages/telefonbooking?ansatt=1 opens the wizard
    // with telefonbooking already expanded on the payment step.
    if (staffFromUrl() && document.getElementById('fb-booking-wizard')) {
      openWizard({});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
